// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file bundles/v1/service.proto (package bundles.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { VersionIncrement, VersionIncrementJson } from "../../asset/v1/asset_pb";
import { file_asset_v1_asset } from "../../asset/v1/asset_pb";
import type {
	ApiLookup,
	ApiLookupJson,
	Asset,
	AssetJson,
	Bundle,
	BundleJson,
	BundleType,
	BundleTypeJson,
	ConversionType,
	ConversionTypeJson,
	CustomCode,
	CustomCodeJson,
	Data,
	DataJson,
	Destination,
	DestinationJson,
	EntryPoint,
	EntryPointJson,
	Header,
	HeaderJson,
	Link,
	LinkJson,
	Module,
	ModuleJson,
	ModuleTemplate,
	ModuleTemplateJson,
	PresentationMode,
	PresentationModeJson,
	RenderMode,
	RenderModeJson,
	Suite,
	SuiteJson,
	TemplateRef,
	TemplateRefJson,
} from "./bundle_pb";
import { file_bundles_v1_bundle } from "./bundle_pb";
import type { GeoLocation, GeoLocationJson } from "./common_pb";
import { file_bundles_v1_common } from "./common_pb";
import type { ConversionMetaData, ConversionMetaDataJson } from "./events_pb";
import { file_bundles_v1_events } from "./events_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { FieldMask, FieldMaskJson, StructJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { BadRequest_FieldViolation, BadRequest_FieldViolationJson } from "../../google/rpc/error_details_pb";
import { file_google_rpc_error_details } from "../../google/rpc/error_details_pb";
import type { Status, StatusJson } from "../../google/rpc/status_pb";
import { file_google_rpc_status } from "../../google/rpc/status_pb";
import type { MappedValue, MappedValueJson } from "../../workflows/v1/workflows_pb";
import { file_workflows_v1_workflows } from "../../workflows/v1/workflows_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file bundles/v1/service.proto.
 */
export const file_bundles_v1_service: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_asset_v1_asset, file_bundles_v1_bundle, file_bundles_v1_common, file_bundles_v1_events, file_common_v1_annotations, file_common_v1_pagination, file_google_api_annotations, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_rpc_error_details, file_google_rpc_status, file_workflows_v1_workflows],
	);

/**
 * @generated from message bundles.v1.CreateBundleRequest
 */
export type CreateBundleRequest = Message<"bundles.v1.CreateBundleRequest"> & {
	/**
	 * @generated from field: string dag_version = 14;
	 */
	dagVersion: string;

	/**
	 * @generated from field: bundles.v1.BundleType bundle_type = 10;
	 */
	bundleType: BundleType;

	/**
	 * @generated from field: string category = 12;
	 */
	category: string;

	/**
	 * @generated from field: repeated string verticals = 15;
	 */
	verticals: string[];

	/**
	 * @generated from field: repeated string features = 16;
	 */
	features: string[];

	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string group_id = 3;
	 */
	groupId?: string | undefined;

	/**
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * @generated from field: optional string description = 5;
	 */
	description?: string | undefined;

	/**
	 * @generated from field: string folder_path = 6;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * @generated from field: string visibility = 11;
	 */
	visibility: string;

	/**
	 * @generated from field: map<string, bundles.v1.TemplateRef> templates = 8;
	 */
	templates: { [key: string]: TemplateRef };

	/**
	 * @generated from field: repeated bundles.v1.Link links = 9;
	 */
	links: Link[];
};

/**
 * @generated from message bundles.v1.CreateBundleRequest
 */
export type CreateBundleRequestJson = {
	/**
	 * @generated from field: string dag_version = 14;
	 */
	dagVersion?: string;

	/**
	 * @generated from field: bundles.v1.BundleType bundle_type = 10;
	 */
	bundleType?: BundleTypeJson;

	/**
	 * @generated from field: string category = 12;
	 */
	category?: string;

	/**
	 * @generated from field: repeated string verticals = 15;
	 */
	verticals?: string[];

	/**
	 * @generated from field: repeated string features = 16;
	 */
	features?: string[];

	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string group_id = 3;
	 */
	groupId?: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * @generated from field: optional string description = 5;
	 */
	description?: string;

	/**
	 * @generated from field: string folder_path = 6;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * @generated from field: string visibility = 11;
	 */
	visibility?: string;

	/**
	 * @generated from field: map<string, bundles.v1.TemplateRef> templates = 8;
	 */
	templates?: { [key: string]: TemplateRefJson };

	/**
	 * @generated from field: repeated bundles.v1.Link links = 9;
	 */
	links?: LinkJson[];
};

/**
 * Describes the message bundles.v1.CreateBundleRequest.
 * Use `create(CreateBundleRequestSchema)` to create a new message.
 */
export const CreateBundleRequestSchema: GenMessage<CreateBundleRequest, { jsonType: CreateBundleRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 0);

/**
 * @generated from message bundles.v1.CreateBundleResponse
 */
export type CreateBundleResponse = Message<"bundles.v1.CreateBundleResponse"> & {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: Bundle | undefined;
};

/**
 * @generated from message bundles.v1.CreateBundleResponse
 */
export type CreateBundleResponseJson = {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: BundleJson;
};

/**
 * Describes the message bundles.v1.CreateBundleResponse.
 * Use `create(CreateBundleResponseSchema)` to create a new message.
 */
export const CreateBundleResponseSchema: GenMessage<CreateBundleResponse, { jsonType: CreateBundleResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 1);

/**
 * @generated from message bundles.v1.CreateBundleFromSuiteRequest
 */
export type CreateBundleFromSuiteRequest = Message<"bundles.v1.CreateBundleFromSuiteRequest"> & {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: optional string suite_version = 2;
	 */
	suiteVersion?: string | undefined;

	/**
	 * @generated from field: optional string group_id = 3;
	 */
	groupId?: string | undefined;

	/**
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * @generated from field: optional string description = 5;
	 */
	description?: string | undefined;

	/**
	 * @generated from field: string folder_path = 6;
	 */
	folderPath: string;

	/**
	 * @generated from field: string visibility = 7;
	 */
	visibility: string;

	/**
	 * @generated from field: string category = 8;
	 */
	category: string;

	/**
	 * @generated from field: repeated string verticals = 9;
	 */
	verticals: string[];

	/**
	 * @generated from field: repeated string features = 10;
	 */
	features: string[];
};

/**
 * @generated from message bundles.v1.CreateBundleFromSuiteRequest
 */
export type CreateBundleFromSuiteRequestJson = {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: optional string suite_version = 2;
	 */
	suiteVersion?: string;

	/**
	 * @generated from field: optional string group_id = 3;
	 */
	groupId?: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * @generated from field: optional string description = 5;
	 */
	description?: string;

	/**
	 * @generated from field: string folder_path = 6;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string visibility = 7;
	 */
	visibility?: string;

	/**
	 * @generated from field: string category = 8;
	 */
	category?: string;

	/**
	 * @generated from field: repeated string verticals = 9;
	 */
	verticals?: string[];

	/**
	 * @generated from field: repeated string features = 10;
	 */
	features?: string[];
};

/**
 * Describes the message bundles.v1.CreateBundleFromSuiteRequest.
 * Use `create(CreateBundleFromSuiteRequestSchema)` to create a new message.
 */
export const CreateBundleFromSuiteRequestSchema: GenMessage<CreateBundleFromSuiteRequest, { jsonType: CreateBundleFromSuiteRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 2);

/**
 * @generated from message bundles.v1.CreateBundleFromSuiteResponse
 */
export type CreateBundleFromSuiteResponse = Message<"bundles.v1.CreateBundleFromSuiteResponse"> & {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: Bundle | undefined;
};

/**
 * @generated from message bundles.v1.CreateBundleFromSuiteResponse
 */
export type CreateBundleFromSuiteResponseJson = {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: BundleJson;
};

/**
 * Describes the message bundles.v1.CreateBundleFromSuiteResponse.
 * Use `create(CreateBundleFromSuiteResponseSchema)` to create a new message.
 */
export const CreateBundleFromSuiteResponseSchema: GenMessage<CreateBundleFromSuiteResponse, { jsonType: CreateBundleFromSuiteResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 3);

/**
 * @generated from message bundles.v1.ExportBundleRequest
 */
export type ExportBundleRequest = Message<"bundles.v1.ExportBundleRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message bundles.v1.ExportBundleRequest
 */
export type ExportBundleRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.ExportBundleRequest.
 * Use `create(ExportBundleRequestSchema)` to create a new message.
 */
export const ExportBundleRequestSchema: GenMessage<ExportBundleRequest, { jsonType: ExportBundleRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 4);

/**
 * @generated from message bundles.v1.ExportBundleResponse
 */
export type ExportBundleResponse = Message<"bundles.v1.ExportBundleResponse"> & {
	/**
	 * @generated from field: string bundle = 2;
	 */
	bundle: string;
};

/**
 * @generated from message bundles.v1.ExportBundleResponse
 */
export type ExportBundleResponseJson = {
	/**
	 * @generated from field: string bundle = 2;
	 */
	bundle?: string;
};

/**
 * Describes the message bundles.v1.ExportBundleResponse.
 * Use `create(ExportBundleResponseSchema)` to create a new message.
 */
export const ExportBundleResponseSchema: GenMessage<ExportBundleResponse, { jsonType: ExportBundleResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 5);

/**
 * @generated from message bundles.v1.ImportBundleRequest
 */
export type ImportBundleRequest = Message<"bundles.v1.ImportBundleRequest"> & {
	/**
	 * @generated from field: string bundle = 1;
	 */
	bundle: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;
};

/**
 * @generated from message bundles.v1.ImportBundleRequest
 */
export type ImportBundleRequestJson = {
	/**
	 * @generated from field: string bundle = 1;
	 */
	bundle?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;
};

/**
 * Describes the message bundles.v1.ImportBundleRequest.
 * Use `create(ImportBundleRequestSchema)` to create a new message.
 */
export const ImportBundleRequestSchema: GenMessage<ImportBundleRequest, { jsonType: ImportBundleRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 6);

/**
 * @generated from message bundles.v1.ImportBundleResponse
 */
export type ImportBundleResponse = Message<"bundles.v1.ImportBundleResponse"> & {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: Bundle | undefined;
};

/**
 * @generated from message bundles.v1.ImportBundleResponse
 */
export type ImportBundleResponseJson = {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: BundleJson;
};

/**
 * Describes the message bundles.v1.ImportBundleResponse.
 * Use `create(ImportBundleResponseSchema)` to create a new message.
 */
export const ImportBundleResponseSchema: GenMessage<ImportBundleResponse, { jsonType: ImportBundleResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 7);

/**
 * @generated from message bundles.v1.GetBundleRequest
 */
export type GetBundleRequest = Message<"bundles.v1.GetBundleRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message bundles.v1.GetBundleRequest
 */
export type GetBundleRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.GetBundleRequest.
 * Use `create(GetBundleRequestSchema)` to create a new message.
 */
export const GetBundleRequestSchema: GenMessage<GetBundleRequest, { jsonType: GetBundleRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 8);

/**
 * @generated from message bundles.v1.GetBundleResponse
 */
export type GetBundleResponse = Message<"bundles.v1.GetBundleResponse"> & {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: Bundle | undefined;
};

/**
 * @generated from message bundles.v1.GetBundleResponse
 */
export type GetBundleResponseJson = {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: BundleJson;
};

/**
 * Describes the message bundles.v1.GetBundleResponse.
 * Use `create(GetBundleResponseSchema)` to create a new message.
 */
export const GetBundleResponseSchema: GenMessage<GetBundleResponse, { jsonType: GetBundleResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 9);

/**
 * @generated from message bundles.v1.CreateBundleVersionRequest
 */
export type CreateBundleVersionRequest = Message<"bundles.v1.CreateBundleVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string base_version = 2;
	 */
	baseVersion: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 3;
	 */
	increment: VersionIncrement;
};

/**
 * @generated from message bundles.v1.CreateBundleVersionRequest
 */
export type CreateBundleVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string base_version = 2;
	 */
	baseVersion?: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 3;
	 */
	increment?: VersionIncrementJson;
};

/**
 * Describes the message bundles.v1.CreateBundleVersionRequest.
 * Use `create(CreateBundleVersionRequestSchema)` to create a new message.
 */
export const CreateBundleVersionRequestSchema: GenMessage<CreateBundleVersionRequest, { jsonType: CreateBundleVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 10);

/**
 * @generated from message bundles.v1.CreateBundleVersionResponse
 */
export type CreateBundleVersionResponse = Message<"bundles.v1.CreateBundleVersionResponse"> & {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: Bundle | undefined;
};

/**
 * @generated from message bundles.v1.CreateBundleVersionResponse
 */
export type CreateBundleVersionResponseJson = {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: BundleJson;
};

/**
 * Describes the message bundles.v1.CreateBundleVersionResponse.
 * Use `create(CreateBundleVersionResponseSchema)` to create a new message.
 */
export const CreateBundleVersionResponseSchema: GenMessage<CreateBundleVersionResponse, { jsonType: CreateBundleVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 11);

/**
 * @generated from message bundles.v1.PublishBundleVersionRequest
 */
export type PublishBundleVersionRequest = Message<"bundles.v1.PublishBundleVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility: string;
};

/**
 * @generated from message bundles.v1.PublishBundleVersionRequest
 */
export type PublishBundleVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility?: string;
};

/**
 * Describes the message bundles.v1.PublishBundleVersionRequest.
 * Use `create(PublishBundleVersionRequestSchema)` to create a new message.
 */
export const PublishBundleVersionRequestSchema: GenMessage<PublishBundleVersionRequest, { jsonType: PublishBundleVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 12);

/**
 * @generated from message bundles.v1.PublishBundleVersionResponse
 */
export type PublishBundleVersionResponse = Message<"bundles.v1.PublishBundleVersionResponse"> & {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: Bundle | undefined;
};

/**
 * @generated from message bundles.v1.PublishBundleVersionResponse
 */
export type PublishBundleVersionResponseJson = {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: BundleJson;
};

/**
 * Describes the message bundles.v1.PublishBundleVersionResponse.
 * Use `create(PublishBundleVersionResponseSchema)` to create a new message.
 */
export const PublishBundleVersionResponseSchema: GenMessage<PublishBundleVersionResponse, { jsonType: PublishBundleVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 13);

/**
 * @generated from message bundles.v1.ListBundleVersionsRequest
 */
export type ListBundleVersionsRequest = Message<"bundles.v1.ListBundleVersionsRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message bundles.v1.ListBundleVersionsRequest
 */
export type ListBundleVersionsRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message bundles.v1.ListBundleVersionsRequest.
 * Use `create(ListBundleVersionsRequestSchema)` to create a new message.
 */
export const ListBundleVersionsRequestSchema: GenMessage<ListBundleVersionsRequest, { jsonType: ListBundleVersionsRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 14);

/**
 * @generated from message bundles.v1.ListBundleVersionsResponse
 */
export type ListBundleVersionsResponse = Message<"bundles.v1.ListBundleVersionsResponse"> & {
	/**
	 * @generated from field: repeated bundles.v1.Bundle bundles = 1;
	 */
	bundles: Bundle[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message bundles.v1.ListBundleVersionsResponse
 */
export type ListBundleVersionsResponseJson = {
	/**
	 * @generated from field: repeated bundles.v1.Bundle bundles = 1;
	 */
	bundles?: BundleJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message bundles.v1.ListBundleVersionsResponse.
 * Use `create(ListBundleVersionsResponseSchema)` to create a new message.
 */
export const ListBundleVersionsResponseSchema: GenMessage<ListBundleVersionsResponse, { jsonType: ListBundleVersionsResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 15);

/**
 * @generated from message bundles.v1.CreateModuleTemplateVersionRequest
 */
export type CreateModuleTemplateVersionRequest = Message<"bundles.v1.CreateModuleTemplateVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string base_version = 2;
	 */
	baseVersion: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 3;
	 */
	increment: VersionIncrement;
};

/**
 * @generated from message bundles.v1.CreateModuleTemplateVersionRequest
 */
export type CreateModuleTemplateVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string base_version = 2;
	 */
	baseVersion?: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 3;
	 */
	increment?: VersionIncrementJson;
};

/**
 * Describes the message bundles.v1.CreateModuleTemplateVersionRequest.
 * Use `create(CreateModuleTemplateVersionRequestSchema)` to create a new message.
 */
export const CreateModuleTemplateVersionRequestSchema: GenMessage<CreateModuleTemplateVersionRequest, { jsonType: CreateModuleTemplateVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 16);

/**
 * @generated from message bundles.v1.CreateModuleTemplateVersionResponse
 */
export type CreateModuleTemplateVersionResponse = Message<"bundles.v1.CreateModuleTemplateVersionResponse"> & {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplate | undefined;
};

/**
 * @generated from message bundles.v1.CreateModuleTemplateVersionResponse
 */
export type CreateModuleTemplateVersionResponseJson = {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplateJson;
};

/**
 * Describes the message bundles.v1.CreateModuleTemplateVersionResponse.
 * Use `create(CreateModuleTemplateVersionResponseSchema)` to create a new message.
 */
export const CreateModuleTemplateVersionResponseSchema: GenMessage<CreateModuleTemplateVersionResponse, { jsonType: CreateModuleTemplateVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 17);

/**
 * @generated from message bundles.v1.PublishModuleTemplateVersionRequest
 */
export type PublishModuleTemplateVersionRequest = Message<"bundles.v1.PublishModuleTemplateVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility: string;
};

/**
 * @generated from message bundles.v1.PublishModuleTemplateVersionRequest
 */
export type PublishModuleTemplateVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility?: string;
};

/**
 * Describes the message bundles.v1.PublishModuleTemplateVersionRequest.
 * Use `create(PublishModuleTemplateVersionRequestSchema)` to create a new message.
 */
export const PublishModuleTemplateVersionRequestSchema: GenMessage<PublishModuleTemplateVersionRequest, { jsonType: PublishModuleTemplateVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 18);

/**
 * @generated from message bundles.v1.PublishModuleTemplateVersionResponse
 */
export type PublishModuleTemplateVersionResponse = Message<"bundles.v1.PublishModuleTemplateVersionResponse"> & {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplate | undefined;
};

/**
 * @generated from message bundles.v1.PublishModuleTemplateVersionResponse
 */
export type PublishModuleTemplateVersionResponseJson = {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplateJson;
};

/**
 * Describes the message bundles.v1.PublishModuleTemplateVersionResponse.
 * Use `create(PublishModuleTemplateVersionResponseSchema)` to create a new message.
 */
export const PublishModuleTemplateVersionResponseSchema: GenMessage<PublishModuleTemplateVersionResponse, { jsonType: PublishModuleTemplateVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 19);

/**
 * @generated from message bundles.v1.ListModuleTemplateVersionsRequest
 */
export type ListModuleTemplateVersionsRequest = Message<"bundles.v1.ListModuleTemplateVersionsRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message bundles.v1.ListModuleTemplateVersionsRequest
 */
export type ListModuleTemplateVersionsRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message bundles.v1.ListModuleTemplateVersionsRequest.
 * Use `create(ListModuleTemplateVersionsRequestSchema)` to create a new message.
 */
export const ListModuleTemplateVersionsRequestSchema: GenMessage<ListModuleTemplateVersionsRequest, { jsonType: ListModuleTemplateVersionsRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 20);

/**
 * @generated from message bundles.v1.ListModuleTemplateVersionsResponse
 */
export type ListModuleTemplateVersionsResponse = Message<"bundles.v1.ListModuleTemplateVersionsResponse"> & {
	/**
	 * @generated from field: repeated bundles.v1.ModuleTemplate templates = 1;
	 */
	templates: ModuleTemplate[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message bundles.v1.ListModuleTemplateVersionsResponse
 */
export type ListModuleTemplateVersionsResponseJson = {
	/**
	 * @generated from field: repeated bundles.v1.ModuleTemplate templates = 1;
	 */
	templates?: ModuleTemplateJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message bundles.v1.ListModuleTemplateVersionsResponse.
 * Use `create(ListModuleTemplateVersionsResponseSchema)` to create a new message.
 */
export const ListModuleTemplateVersionsResponseSchema: GenMessage<ListModuleTemplateVersionsResponse, { jsonType: ListModuleTemplateVersionsResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 21);

/**
 * @generated from message bundles.v1.Category
 */
export type Category = Message<"bundles.v1.Category"> & {
	/**
	 * @generated from field: string category = 1;
	 */
	category: string;

	/**
	 * @generated from field: int64 count = 2;
	 */
	count: bigint;
};

/**
 * @generated from message bundles.v1.Category
 */
export type CategoryJson = {
	/**
	 * @generated from field: string category = 1;
	 */
	category?: string;

	/**
	 * @generated from field: int64 count = 2;
	 */
	count?: string;
};

/**
 * Describes the message bundles.v1.Category.
 * Use `create(CategorySchema)` to create a new message.
 */
export const CategorySchema: GenMessage<Category, { jsonType: CategoryJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 22);

/**
 * @generated from message bundles.v1.GetBundleCategoriesRequest
 */
export type GetBundleCategoriesRequest = Message<"bundles.v1.GetBundleCategoriesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;
};

/**
 * @generated from message bundles.v1.GetBundleCategoriesRequest
 */
export type GetBundleCategoriesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;
};

/**
 * Describes the message bundles.v1.GetBundleCategoriesRequest.
 * Use `create(GetBundleCategoriesRequestSchema)` to create a new message.
 */
export const GetBundleCategoriesRequestSchema: GenMessage<GetBundleCategoriesRequest, { jsonType: GetBundleCategoriesRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 23);

/**
 * @generated from message bundles.v1.GetBundleCategoriesResponse
 */
export type GetBundleCategoriesResponse = Message<"bundles.v1.GetBundleCategoriesResponse"> & {
	/**
	 * @generated from field: repeated bundles.v1.Category categories = 1;
	 */
	categories: Category[];
};

/**
 * @generated from message bundles.v1.GetBundleCategoriesResponse
 */
export type GetBundleCategoriesResponseJson = {
	/**
	 * @generated from field: repeated bundles.v1.Category categories = 1;
	 */
	categories?: CategoryJson[];
};

/**
 * Describes the message bundles.v1.GetBundleCategoriesResponse.
 * Use `create(GetBundleCategoriesResponseSchema)` to create a new message.
 */
export const GetBundleCategoriesResponseSchema: GenMessage<GetBundleCategoriesResponse, { jsonType: GetBundleCategoriesResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 24);

/**
 * @generated from message bundles.v1.GetModuleTemplateCategoriesRequest
 */
export type GetModuleTemplateCategoriesRequest = Message<"bundles.v1.GetModuleTemplateCategoriesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;
};

/**
 * @generated from message bundles.v1.GetModuleTemplateCategoriesRequest
 */
export type GetModuleTemplateCategoriesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;
};

/**
 * Describes the message bundles.v1.GetModuleTemplateCategoriesRequest.
 * Use `create(GetModuleTemplateCategoriesRequestSchema)` to create a new message.
 */
export const GetModuleTemplateCategoriesRequestSchema: GenMessage<GetModuleTemplateCategoriesRequest, { jsonType: GetModuleTemplateCategoriesRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 25);

/**
 * @generated from message bundles.v1.GetModuleTemplateCategoriesResponse
 */
export type GetModuleTemplateCategoriesResponse = Message<"bundles.v1.GetModuleTemplateCategoriesResponse"> & {
	/**
	 * @generated from field: repeated bundles.v1.Category categories = 1;
	 */
	categories: Category[];
};

/**
 * @generated from message bundles.v1.GetModuleTemplateCategoriesResponse
 */
export type GetModuleTemplateCategoriesResponseJson = {
	/**
	 * @generated from field: repeated bundles.v1.Category categories = 1;
	 */
	categories?: CategoryJson[];
};

/**
 * Describes the message bundles.v1.GetModuleTemplateCategoriesResponse.
 * Use `create(GetModuleTemplateCategoriesResponseSchema)` to create a new message.
 */
export const GetModuleTemplateCategoriesResponseSchema: GenMessage<GetModuleTemplateCategoriesResponse, { jsonType: GetModuleTemplateCategoriesResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 26);

/**
 * @generated from message bundles.v1.UpdateBundleRequest
 */
export type UpdateBundleRequest = Message<"bundles.v1.UpdateBundleRequest"> & {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: Bundle | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message bundles.v1.UpdateBundleRequest
 */
export type UpdateBundleRequestJson = {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: BundleJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message bundles.v1.UpdateBundleRequest.
 * Use `create(UpdateBundleRequestSchema)` to create a new message.
 */
export const UpdateBundleRequestSchema: GenMessage<UpdateBundleRequest, { jsonType: UpdateBundleRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 27);

/**
 * @generated from message bundles.v1.UpdateBundleResponse
 */
export type UpdateBundleResponse = Message<"bundles.v1.UpdateBundleResponse"> & {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: Bundle | undefined;
};

/**
 * @generated from message bundles.v1.UpdateBundleResponse
 */
export type UpdateBundleResponseJson = {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: BundleJson;
};

/**
 * Describes the message bundles.v1.UpdateBundleResponse.
 * Use `create(UpdateBundleResponseSchema)` to create a new message.
 */
export const UpdateBundleResponseSchema: GenMessage<UpdateBundleResponse, { jsonType: UpdateBundleResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 28);

/**
 * @generated from message bundles.v1.DeleteBundleRequest
 */
export type DeleteBundleRequest = Message<"bundles.v1.DeleteBundleRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message bundles.v1.DeleteBundleRequest
 */
export type DeleteBundleRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.DeleteBundleRequest.
 * Use `create(DeleteBundleRequestSchema)` to create a new message.
 */
export const DeleteBundleRequestSchema: GenMessage<DeleteBundleRequest, { jsonType: DeleteBundleRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 29);

/**
 * @generated from message bundles.v1.DeleteBundleResponse
 */
export type DeleteBundleResponse = Message<"bundles.v1.DeleteBundleResponse"> & {};

/**
 * @generated from message bundles.v1.DeleteBundleResponse
 */
export type DeleteBundleResponseJson = {};

/**
 * Describes the message bundles.v1.DeleteBundleResponse.
 * Use `create(DeleteBundleResponseSchema)` to create a new message.
 */
export const DeleteBundleResponseSchema: GenMessage<DeleteBundleResponse, { jsonType: DeleteBundleResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 30);

/**
 * @generated from message bundles.v1.CreateSuiteRequest
 */
export type CreateSuiteRequest = Message<"bundles.v1.CreateSuiteRequest"> & {
	/**
	 * Org ID is the organization that the suite belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the suite belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * State of the suite (ASSET_STATE_ACTIVE, ASSET_STATE_ARCHIVED, ASSET_STATE_DRAFT).
	 *
	 * @generated from field: string state = 13;
	 */
	state: string;

	/**
	 * Bundle ID is the id of the bundle the suite should be created with.
	 *
	 * @generated from field: string bundle_id = 3;
	 */
	bundleId: string;

	/**
	 * Bundle version is the version of the bundle the suite should be created with.
	 *
	 * @generated from field: string bundle_version = 12;
	 */
	bundleVersion: string;

	/**
	 * Optional. Brand kit ID is the id of the brand kit the suite should be created with.
	 *
	 * @generated from field: optional string brand_kit_id = 4;
	 */
	brandKitId?: string | undefined;

	/**
	 * Name of the suite.
	 *
	 * @generated from field: string name = 5;
	 */
	name: string;

	/**
	 * Optional. Description of the suite.
	 *
	 * @generated from field: optional string description = 6;
	 */
	description?: string | undefined;

	/**
	 * Folder path of the suite.
	 *
	 * @generated from field: string folder_path = 7;
	 */
	folderPath: string;

	/**
	 * List of tags associated with the suite.
	 *
	 * @generated from field: repeated string tags = 8;
	 */
	tags: string[];

	/**
	 * Domain of the suite, used for codes/short urls.
	 *
	 * @generated from field: string domain = 9;
	 */
	domain: string;

	/**
	 * Config is a map containing asset-specific configurations, inferred from the bundle structure.
	 *
	 * @generated from field: map<string, google.protobuf.Struct> config = 10;
	 */
	config: { [key: string]: JsonObject };

	/**
	 * Data is a message that represents the data that is associated with a suite.
	 *
	 * @generated from field: bundles.v1.Data data = 11;
	 */
	data?: Data | undefined;

	/**
	 * Optional. Timezone of the suite.
	 *
	 * @generated from field: optional string timezone = 14;
	 */
	timezone?: string | undefined;

	/**
	 * Enable advanced geolocation features.
	 *
	 * @generated from field: bool advanced_geo_enabled = 15;
	 */
	advancedGeoEnabled: boolean;

	/**
	 * Enable desktop view for the suite. Defaults to true
	 *
	 * @generated from field: optional bool desktop_view_enabled = 16;
	 */
	desktopViewEnabled?: boolean | undefined;

	/**
	 * Optional. Calendar ID associated with the suite for event data.
	 *
	 * @generated from field: repeated string calendar_ids = 17;
	 */
	calendarIds: string[];

	/**
	 * Optional. Raw head/body markup injected into every page of the suite.
	 *
	 * @generated from field: bundles.v1.CustomCode custom_code = 18;
	 */
	customCode?: CustomCode | undefined;

	/**
	 * Optional. Flow-level default for how newly created pages present.
	 *
	 * @generated from field: bundles.v1.PresentationMode default_presentation_mode = 19;
	 */
	defaultPresentationMode: PresentationMode;
};

/**
 * @generated from message bundles.v1.CreateSuiteRequest
 */
export type CreateSuiteRequestJson = {
	/**
	 * Org ID is the organization that the suite belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the suite belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * State of the suite (ASSET_STATE_ACTIVE, ASSET_STATE_ARCHIVED, ASSET_STATE_DRAFT).
	 *
	 * @generated from field: string state = 13;
	 */
	state?: string;

	/**
	 * Bundle ID is the id of the bundle the suite should be created with.
	 *
	 * @generated from field: string bundle_id = 3;
	 */
	bundleId?: string;

	/**
	 * Bundle version is the version of the bundle the suite should be created with.
	 *
	 * @generated from field: string bundle_version = 12;
	 */
	bundleVersion?: string;

	/**
	 * Optional. Brand kit ID is the id of the brand kit the suite should be created with.
	 *
	 * @generated from field: optional string brand_kit_id = 4;
	 */
	brandKitId?: string;

	/**
	 * Name of the suite.
	 *
	 * @generated from field: string name = 5;
	 */
	name?: string;

	/**
	 * Optional. Description of the suite.
	 *
	 * @generated from field: optional string description = 6;
	 */
	description?: string;

	/**
	 * Folder path of the suite.
	 *
	 * @generated from field: string folder_path = 7;
	 */
	folderPath?: string;

	/**
	 * List of tags associated with the suite.
	 *
	 * @generated from field: repeated string tags = 8;
	 */
	tags?: string[];

	/**
	 * Domain of the suite, used for codes/short urls.
	 *
	 * @generated from field: string domain = 9;
	 */
	domain?: string;

	/**
	 * Config is a map containing asset-specific configurations, inferred from the bundle structure.
	 *
	 * @generated from field: map<string, google.protobuf.Struct> config = 10;
	 */
	config?: { [key: string]: StructJson };

	/**
	 * Data is a message that represents the data that is associated with a suite.
	 *
	 * @generated from field: bundles.v1.Data data = 11;
	 */
	data?: DataJson;

	/**
	 * Optional. Timezone of the suite.
	 *
	 * @generated from field: optional string timezone = 14;
	 */
	timezone?: string;

	/**
	 * Enable advanced geolocation features.
	 *
	 * @generated from field: bool advanced_geo_enabled = 15;
	 */
	advancedGeoEnabled?: boolean;

	/**
	 * Enable desktop view for the suite. Defaults to true
	 *
	 * @generated from field: optional bool desktop_view_enabled = 16;
	 */
	desktopViewEnabled?: boolean;

	/**
	 * Optional. Calendar ID associated with the suite for event data.
	 *
	 * @generated from field: repeated string calendar_ids = 17;
	 */
	calendarIds?: string[];

	/**
	 * Optional. Raw head/body markup injected into every page of the suite.
	 *
	 * @generated from field: bundles.v1.CustomCode custom_code = 18;
	 */
	customCode?: CustomCodeJson;

	/**
	 * Optional. Flow-level default for how newly created pages present.
	 *
	 * @generated from field: bundles.v1.PresentationMode default_presentation_mode = 19;
	 */
	defaultPresentationMode?: PresentationModeJson;
};

/**
 * Describes the message bundles.v1.CreateSuiteRequest.
 * Use `create(CreateSuiteRequestSchema)` to create a new message.
 */
export const CreateSuiteRequestSchema: GenMessage<CreateSuiteRequest, { jsonType: CreateSuiteRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 31);

/**
 * @generated from message bundles.v1.CreateSuiteResponse
 */
export type CreateSuiteResponse = Message<"bundles.v1.CreateSuiteResponse"> & {
	/**
	 * Suite that was created.
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;
};

/**
 * @generated from message bundles.v1.CreateSuiteResponse
 */
export type CreateSuiteResponseJson = {
	/**
	 * Suite that was created.
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;
};

/**
 * Describes the message bundles.v1.CreateSuiteResponse.
 * Use `create(CreateSuiteResponseSchema)` to create a new message.
 */
export const CreateSuiteResponseSchema: GenMessage<CreateSuiteResponse, { jsonType: CreateSuiteResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 32);

/**
 * @generated from message bundles.v1.CloneOptions
 */
export type CloneOptions = Message<"bundles.v1.CloneOptions"> & {
	/**
	 * @generated from field: bool clone_entrypoints = 1;
	 */
	cloneEntrypoints: boolean;
};

/**
 * @generated from message bundles.v1.CloneOptions
 */
export type CloneOptionsJson = {
	/**
	 * @generated from field: bool clone_entrypoints = 1;
	 */
	cloneEntrypoints?: boolean;
};

/**
 * Describes the message bundles.v1.CloneOptions.
 * Use `create(CloneOptionsSchema)` to create a new message.
 */
export const CloneOptionsSchema: GenMessage<CloneOptions, { jsonType: CloneOptionsJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 33);

/**
 * @generated from message bundles.v1.CloneSuiteRequest
 */
export type CloneSuiteRequest = Message<"bundles.v1.CloneSuiteRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: bundles.v1.CloneOptions options = 3;
	 */
	options?: CloneOptions | undefined;
};

/**
 * @generated from message bundles.v1.CloneSuiteRequest
 */
export type CloneSuiteRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: bundles.v1.CloneOptions options = 3;
	 */
	options?: CloneOptionsJson;
};

/**
 * Describes the message bundles.v1.CloneSuiteRequest.
 * Use `create(CloneSuiteRequestSchema)` to create a new message.
 */
export const CloneSuiteRequestSchema: GenMessage<CloneSuiteRequest, { jsonType: CloneSuiteRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 34);

/**
 * @generated from message bundles.v1.CloneSuiteResponse
 */
export type CloneSuiteResponse = Message<"bundles.v1.CloneSuiteResponse"> & {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;
};

/**
 * @generated from message bundles.v1.CloneSuiteResponse
 */
export type CloneSuiteResponseJson = {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;
};

/**
 * Describes the message bundles.v1.CloneSuiteResponse.
 * Use `create(CloneSuiteResponseSchema)` to create a new message.
 */
export const CloneSuiteResponseSchema: GenMessage<CloneSuiteResponse, { jsonType: CloneSuiteResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 35);

/**
 * @generated from message bundles.v1.BulkImportSuitesRequest
 */
export type BulkImportSuitesRequest = Message<"bundles.v1.BulkImportSuitesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string bundle_id = 3;
	 */
	bundleId: string;

	/**
	 * @generated from field: string bundle_version = 4;
	 */
	bundleVersion: string;

	/**
	 * @generated from field: optional string brand_kit_id = 5;
	 */
	brandKitId?: string | undefined;

	/**
	 * @generated from field: string domain = 6;
	 */
	domain: string;

	/**
	 * @generated from field: string folder_path = 7;
	 */
	folderPath: string;

	/**
	 * @generated from field: string file_url = 8;
	 */
	fileUrl: string;

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 9;
	 */
	mapping: { [key: string]: MappedValue };

	/**
	 * @generated from field: bool has_header = 10;
	 */
	hasHeader: boolean;

	/**
	 * @generated from field: repeated string header = 11;
	 */
	header: string[];
};

/**
 * @generated from message bundles.v1.BulkImportSuitesRequest
 */
export type BulkImportSuitesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string bundle_id = 3;
	 */
	bundleId?: string;

	/**
	 * @generated from field: string bundle_version = 4;
	 */
	bundleVersion?: string;

	/**
	 * @generated from field: optional string brand_kit_id = 5;
	 */
	brandKitId?: string;

	/**
	 * @generated from field: string domain = 6;
	 */
	domain?: string;

	/**
	 * @generated from field: string folder_path = 7;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string file_url = 8;
	 */
	fileUrl?: string;

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 9;
	 */
	mapping?: { [key: string]: MappedValueJson };

	/**
	 * @generated from field: bool has_header = 10;
	 */
	hasHeader?: boolean;

	/**
	 * @generated from field: repeated string header = 11;
	 */
	header?: string[];
};

/**
 * Describes the message bundles.v1.BulkImportSuitesRequest.
 * Use `create(BulkImportSuitesRequestSchema)` to create a new message.
 */
export const BulkImportSuitesRequestSchema: GenMessage<BulkImportSuitesRequest, { jsonType: BulkImportSuitesRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 36);

/**
 * @generated from message bundles.v1.BulkImportSuitesResponse
 */
export type BulkImportSuitesResponse = Message<"bundles.v1.BulkImportSuitesResponse"> & {};

/**
 * @generated from message bundles.v1.BulkImportSuitesResponse
 */
export type BulkImportSuitesResponseJson = {};

/**
 * Describes the message bundles.v1.BulkImportSuitesResponse.
 * Use `create(BulkImportSuitesResponseSchema)` to create a new message.
 */
export const BulkImportSuitesResponseSchema: GenMessage<BulkImportSuitesResponse, { jsonType: BulkImportSuitesResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 37);

/**
 * @generated from message bundles.v1.ListBundlesRequest
 */
export type ListBundlesRequest = Message<"bundles.v1.ListBundlesRequest"> & {
	/**
	 * Org ID is the organization that the bundles belong to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the bundles belong to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Show only bundles belonging to this folder path.
	 *
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * Deprecated. Use creator_ids instead.
	 *
	 * @generated from field: string creator_id = 5 [deprecated = true];
	 * @deprecated
	 */
	creatorId: string;

	/**
	 * Show only bundles that include this prefix in the name.
	 *
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix: string;

	/**
	 * Show only bundles that include a tag from this list of tags.
	 *
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * Show only bundles that are in a state from this list of states.
	 *
	 * @generated from field: repeated string states = 9;
	 */
	states: string[];

	/**
	 * Show only bundles that are of a visibility from the list of visibilities.
	 *
	 * @generated from field: repeated string visibilities = 10;
	 */
	visibilities: string[];

	/**
	 * Show only bundles that are in a category from this list of categories.
	 *
	 * @generated from field: repeated string categories = 11;
	 */
	categories: string[];

	/**
	 * Show only bundles that are created by a creator id from this list of creator ids.
	 *
	 * @generated from field: repeated string creator_ids = 12;
	 */
	creatorIds: string[];

	/**
	 * Pagination arguments.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message bundles.v1.ListBundlesRequest
 */
export type ListBundlesRequestJson = {
	/**
	 * Org ID is the organization that the bundles belong to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the bundles belong to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Show only bundles belonging to this folder path.
	 *
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * Deprecated. Use creator_ids instead.
	 *
	 * @generated from field: string creator_id = 5 [deprecated = true];
	 * @deprecated
	 */
	creatorId?: string;

	/**
	 * Show only bundles that include this prefix in the name.
	 *
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix?: string;

	/**
	 * Show only bundles that include a tag from this list of tags.
	 *
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * Show only bundles that are in a state from this list of states.
	 *
	 * @generated from field: repeated string states = 9;
	 */
	states?: string[];

	/**
	 * Show only bundles that are of a visibility from the list of visibilities.
	 *
	 * @generated from field: repeated string visibilities = 10;
	 */
	visibilities?: string[];

	/**
	 * Show only bundles that are in a category from this list of categories.
	 *
	 * @generated from field: repeated string categories = 11;
	 */
	categories?: string[];

	/**
	 * Show only bundles that are created by a creator id from this list of creator ids.
	 *
	 * @generated from field: repeated string creator_ids = 12;
	 */
	creatorIds?: string[];

	/**
	 * Pagination arguments.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message bundles.v1.ListBundlesRequest.
 * Use `create(ListBundlesRequestSchema)` to create a new message.
 */
export const ListBundlesRequestSchema: GenMessage<ListBundlesRequest, { jsonType: ListBundlesRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 38);

/**
 * @generated from message bundles.v1.ListBundlesResponse
 */
export type ListBundlesResponse = Message<"bundles.v1.ListBundlesResponse"> & {
	/**
	 * List of bundles that match the query.
	 *
	 * @generated from field: repeated bundles.v1.Bundle bundles = 1;
	 */
	bundles: Bundle[];

	/**
	 * Pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message bundles.v1.ListBundlesResponse
 */
export type ListBundlesResponseJson = {
	/**
	 * List of bundles that match the query.
	 *
	 * @generated from field: repeated bundles.v1.Bundle bundles = 1;
	 */
	bundles?: BundleJson[];

	/**
	 * Pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message bundles.v1.ListBundlesResponse.
 * Use `create(ListBundlesResponseSchema)` to create a new message.
 */
export const ListBundlesResponseSchema: GenMessage<ListBundlesResponse, { jsonType: ListBundlesResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 39);

/**
 * @generated from message bundles.v1.GetSuiteRequest
 */
export type GetSuiteRequest = Message<"bundles.v1.GetSuiteRequest"> & {
	/**
	 * ID of the suite.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message bundles.v1.GetSuiteRequest
 */
export type GetSuiteRequestJson = {
	/**
	 * ID of the suite.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.GetSuiteRequest.
 * Use `create(GetSuiteRequestSchema)` to create a new message.
 */
export const GetSuiteRequestSchema: GenMessage<GetSuiteRequest, { jsonType: GetSuiteRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 40);

/**
 * @generated from message bundles.v1.GetSuiteResponse
 */
export type GetSuiteResponse = Message<"bundles.v1.GetSuiteResponse"> & {
	/**
	 * Suite that was retrieved.
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;
};

/**
 * @generated from message bundles.v1.GetSuiteResponse
 */
export type GetSuiteResponseJson = {
	/**
	 * Suite that was retrieved.
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;
};

/**
 * Describes the message bundles.v1.GetSuiteResponse.
 * Use `create(GetSuiteResponseSchema)` to create a new message.
 */
export const GetSuiteResponseSchema: GenMessage<GetSuiteResponse, { jsonType: GetSuiteResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 41);

/**
 * @generated from message bundles.v1.ListSuitesRequest
 */
export type ListSuitesRequest = Message<"bundles.v1.ListSuitesRequest"> & {
	/**
	 * Org ID is the organization that the suites belong to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the suites belong to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Show only suites belonging to this folder path.
	 *
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * Deprecated. Use creator_ids instead.
	 *
	 * @generated from field: string creator_id = 5 [deprecated = true];
	 * @deprecated
	 */
	creatorId: string;

	/**
	 * Show only suites that include this prefix in the name.
	 *
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix: string;

	/**
	 * Show only suites that include a tag from this list of tags.
	 *
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * Show only suites that are in a state from this list of states.
	 *
	 * @generated from field: repeated string states = 8;
	 */
	states: string[];

	/**
	 * Show only suites that are in a category from this list of categories.
	 *
	 * @generated from field: repeated string categories = 9;
	 */
	categories: string[];

	/**
	 * Show only suites that are created by a creator id from this list of creator ids.
	 *
	 * @generated from field: repeated string creator_ids = 10;
	 */
	creatorIds: string[];

	/**
	 * Show only suites that have this external id (product id for product selling suites or an mls id for a listing suite).
	 *
	 * @generated from field: string external_id = 11;
	 */
	externalId: string;

	/**
	 * Pagination arguments.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message bundles.v1.ListSuitesRequest
 */
export type ListSuitesRequestJson = {
	/**
	 * Org ID is the organization that the suites belong to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the suites belong to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Show only suites belonging to this folder path.
	 *
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * Deprecated. Use creator_ids instead.
	 *
	 * @generated from field: string creator_id = 5 [deprecated = true];
	 * @deprecated
	 */
	creatorId?: string;

	/**
	 * Show only suites that include this prefix in the name.
	 *
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix?: string;

	/**
	 * Show only suites that include a tag from this list of tags.
	 *
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * Show only suites that are in a state from this list of states.
	 *
	 * @generated from field: repeated string states = 8;
	 */
	states?: string[];

	/**
	 * Show only suites that are in a category from this list of categories.
	 *
	 * @generated from field: repeated string categories = 9;
	 */
	categories?: string[];

	/**
	 * Show only suites that are created by a creator id from this list of creator ids.
	 *
	 * @generated from field: repeated string creator_ids = 10;
	 */
	creatorIds?: string[];

	/**
	 * Show only suites that have this external id (product id for product selling suites or an mls id for a listing suite).
	 *
	 * @generated from field: string external_id = 11;
	 */
	externalId?: string;

	/**
	 * Pagination arguments.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message bundles.v1.ListSuitesRequest.
 * Use `create(ListSuitesRequestSchema)` to create a new message.
 */
export const ListSuitesRequestSchema: GenMessage<ListSuitesRequest, { jsonType: ListSuitesRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 42);

/**
 * @generated from message bundles.v1.ListSuitesResponse
 */
export type ListSuitesResponse = Message<"bundles.v1.ListSuitesResponse"> & {
	/**
	 * List of suites that match the query.
	 *
	 * @generated from field: repeated bundles.v1.Suite suites = 1;
	 */
	suites: Suite[];

	/**
	 * Pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message bundles.v1.ListSuitesResponse
 */
export type ListSuitesResponseJson = {
	/**
	 * List of suites that match the query.
	 *
	 * @generated from field: repeated bundles.v1.Suite suites = 1;
	 */
	suites?: SuiteJson[];

	/**
	 * Pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message bundles.v1.ListSuitesResponse.
 * Use `create(ListSuitesResponseSchema)` to create a new message.
 */
export const ListSuitesResponseSchema: GenMessage<ListSuitesResponse, { jsonType: ListSuitesResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 43);

/**
 * @generated from message bundles.v1.ListSuiteVersionsRequest
 */
export type ListSuiteVersionsRequest = Message<"bundles.v1.ListSuiteVersionsRequest"> & {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string state = 4;
	 */
	state?: string | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 5;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message bundles.v1.ListSuiteVersionsRequest
 */
export type ListSuiteVersionsRequestJson = {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string state = 4;
	 */
	state?: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 5;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message bundles.v1.ListSuiteVersionsRequest.
 * Use `create(ListSuiteVersionsRequestSchema)` to create a new message.
 */
export const ListSuiteVersionsRequestSchema: GenMessage<ListSuiteVersionsRequest, { jsonType: ListSuiteVersionsRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 44);

/**
 * @generated from message bundles.v1.ListSuiteVersionsResponse
 */
export type ListSuiteVersionsResponse = Message<"bundles.v1.ListSuiteVersionsResponse"> & {
	/**
	 * @generated from field: repeated bundles.v1.Suite suites = 1;
	 */
	suites: Suite[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message bundles.v1.ListSuiteVersionsResponse
 */
export type ListSuiteVersionsResponseJson = {
	/**
	 * @generated from field: repeated bundles.v1.Suite suites = 1;
	 */
	suites?: SuiteJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message bundles.v1.ListSuiteVersionsResponse.
 * Use `create(ListSuiteVersionsResponseSchema)` to create a new message.
 */
export const ListSuiteVersionsResponseSchema: GenMessage<ListSuiteVersionsResponse, { jsonType: ListSuiteVersionsResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 45);

/**
 * @generated from message bundles.v1.UpdateSuiteRequest
 */
export type UpdateSuiteRequest = Message<"bundles.v1.UpdateSuiteRequest"> & {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;

	/**
	 * Mask of fields to update.
	 *
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;

	/**
	 * @generated from field: optional bool ignore_analytics = 3;
	 */
	ignoreAnalytics?: boolean | undefined;
};

/**
 * @generated from message bundles.v1.UpdateSuiteRequest
 */
export type UpdateSuiteRequestJson = {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;

	/**
	 * Mask of fields to update.
	 *
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;

	/**
	 * @generated from field: optional bool ignore_analytics = 3;
	 */
	ignoreAnalytics?: boolean;
};

/**
 * Describes the message bundles.v1.UpdateSuiteRequest.
 * Use `create(UpdateSuiteRequestSchema)` to create a new message.
 */
export const UpdateSuiteRequestSchema: GenMessage<UpdateSuiteRequest, { jsonType: UpdateSuiteRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 46);

/**
 * @generated from message bundles.v1.UpdateSuiteResponse
 */
export type UpdateSuiteResponse = Message<"bundles.v1.UpdateSuiteResponse"> & {
	/**
	 * Updated suite.
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;
};

/**
 * @generated from message bundles.v1.UpdateSuiteResponse
 */
export type UpdateSuiteResponseJson = {
	/**
	 * Updated suite.
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;
};

/**
 * Describes the message bundles.v1.UpdateSuiteResponse.
 * Use `create(UpdateSuiteResponseSchema)` to create a new message.
 */
export const UpdateSuiteResponseSchema: GenMessage<UpdateSuiteResponse, { jsonType: UpdateSuiteResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 47);

/**
 * @generated from message bundles.v1.CreateSuiteVersionRequest
 */
export type CreateSuiteVersionRequest = Message<"bundles.v1.CreateSuiteVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string base_version = 2;
	 */
	baseVersion: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 3;
	 */
	increment: VersionIncrement;
};

/**
 * @generated from message bundles.v1.CreateSuiteVersionRequest
 */
export type CreateSuiteVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string base_version = 2;
	 */
	baseVersion?: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 3;
	 */
	increment?: VersionIncrementJson;
};

/**
 * Describes the message bundles.v1.CreateSuiteVersionRequest.
 * Use `create(CreateSuiteVersionRequestSchema)` to create a new message.
 */
export const CreateSuiteVersionRequestSchema: GenMessage<CreateSuiteVersionRequest, { jsonType: CreateSuiteVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 48);

/**
 * @generated from message bundles.v1.CreateSuiteVersionResponse
 */
export type CreateSuiteVersionResponse = Message<"bundles.v1.CreateSuiteVersionResponse"> & {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;
};

/**
 * @generated from message bundles.v1.CreateSuiteVersionResponse
 */
export type CreateSuiteVersionResponseJson = {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;
};

/**
 * Describes the message bundles.v1.CreateSuiteVersionResponse.
 * Use `create(CreateSuiteVersionResponseSchema)` to create a new message.
 */
export const CreateSuiteVersionResponseSchema: GenMessage<CreateSuiteVersionResponse, { jsonType: CreateSuiteVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 49);

/**
 * @generated from message bundles.v1.PublishSuiteVersionRequest
 */
export type PublishSuiteVersionRequest = Message<"bundles.v1.PublishSuiteVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message bundles.v1.PublishSuiteVersionRequest
 */
export type PublishSuiteVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.PublishSuiteVersionRequest.
 * Use `create(PublishSuiteVersionRequestSchema)` to create a new message.
 */
export const PublishSuiteVersionRequestSchema: GenMessage<PublishSuiteVersionRequest, { jsonType: PublishSuiteVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 50);

/**
 * @generated from message bundles.v1.PublishSuiteVersionResponse
 */
export type PublishSuiteVersionResponse = Message<"bundles.v1.PublishSuiteVersionResponse"> & {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;
};

/**
 * @generated from message bundles.v1.PublishSuiteVersionResponse
 */
export type PublishSuiteVersionResponseJson = {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;
};

/**
 * Describes the message bundles.v1.PublishSuiteVersionResponse.
 * Use `create(PublishSuiteVersionResponseSchema)` to create a new message.
 */
export const PublishSuiteVersionResponseSchema: GenMessage<PublishSuiteVersionResponse, { jsonType: PublishSuiteVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 51);

/**
 * @generated from message bundles.v1.ValidateSuiteRequest
 */
export type ValidateSuiteRequest = Message<"bundles.v1.ValidateSuiteRequest"> & {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;
};

/**
 * @generated from message bundles.v1.ValidateSuiteRequest
 */
export type ValidateSuiteRequestJson = {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;
};

/**
 * Describes the message bundles.v1.ValidateSuiteRequest.
 * Use `create(ValidateSuiteRequestSchema)` to create a new message.
 */
export const ValidateSuiteRequestSchema: GenMessage<ValidateSuiteRequest, { jsonType: ValidateSuiteRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 52);

/**
 * @generated from message bundles.v1.ValidateSuiteResponse
 */
export type ValidateSuiteResponse = Message<"bundles.v1.ValidateSuiteResponse"> & {
	/**
	 * @generated from field: bool valid = 1;
	 */
	valid: boolean;

	/**
	 * @generated from field: repeated google.rpc.BadRequest.FieldViolation errors = 2;
	 */
	errors: BadRequest_FieldViolation[];
};

/**
 * @generated from message bundles.v1.ValidateSuiteResponse
 */
export type ValidateSuiteResponseJson = {
	/**
	 * @generated from field: bool valid = 1;
	 */
	valid?: boolean;

	/**
	 * @generated from field: repeated google.rpc.BadRequest.FieldViolation errors = 2;
	 */
	errors?: BadRequest_FieldViolationJson[];
};

/**
 * Describes the message bundles.v1.ValidateSuiteResponse.
 * Use `create(ValidateSuiteResponseSchema)` to create a new message.
 */
export const ValidateSuiteResponseSchema: GenMessage<ValidateSuiteResponse, { jsonType: ValidateSuiteResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 53);

/**
 * @generated from message bundles.v1.BulkUpdateSuiteRequest
 */
export type BulkUpdateSuiteRequest = Message<"bundles.v1.BulkUpdateSuiteRequest"> & {
	/**
	 * @generated from field: repeated bundles.v1.UpdateSuiteRequest requests = 1;
	 */
	requests: UpdateSuiteRequest[];
};

/**
 * @generated from message bundles.v1.BulkUpdateSuiteRequest
 */
export type BulkUpdateSuiteRequestJson = {
	/**
	 * @generated from field: repeated bundles.v1.UpdateSuiteRequest requests = 1;
	 */
	requests?: UpdateSuiteRequestJson[];
};

/**
 * Describes the message bundles.v1.BulkUpdateSuiteRequest.
 * Use `create(BulkUpdateSuiteRequestSchema)` to create a new message.
 */
export const BulkUpdateSuiteRequestSchema: GenMessage<BulkUpdateSuiteRequest, { jsonType: BulkUpdateSuiteRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 54);

/**
 * @generated from message bundles.v1.BulkUpdateSuiteResponse
 */
export type BulkUpdateSuiteResponse = Message<"bundles.v1.BulkUpdateSuiteResponse"> & {
	/**
	 * @generated from field: bundles.v1.UpdateSuiteResponse response = 1;
	 */
	response?: UpdateSuiteResponse | undefined;

	/**
	 * @generated from field: google.rpc.Status status = 2;
	 */
	status?: Status | undefined;
};

/**
 * @generated from message bundles.v1.BulkUpdateSuiteResponse
 */
export type BulkUpdateSuiteResponseJson = {
	/**
	 * @generated from field: bundles.v1.UpdateSuiteResponse response = 1;
	 */
	response?: UpdateSuiteResponseJson;

	/**
	 * @generated from field: google.rpc.Status status = 2;
	 */
	status?: StatusJson;
};

/**
 * Describes the message bundles.v1.BulkUpdateSuiteResponse.
 * Use `create(BulkUpdateSuiteResponseSchema)` to create a new message.
 */
export const BulkUpdateSuiteResponseSchema: GenMessage<BulkUpdateSuiteResponse, { jsonType: BulkUpdateSuiteResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 55);

/**
 * @generated from message bundles.v1.DeleteSuiteRequest
 */
export type DeleteSuiteRequest = Message<"bundles.v1.DeleteSuiteRequest"> & {
	/**
	 * ID of the suite.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message bundles.v1.DeleteSuiteRequest
 */
export type DeleteSuiteRequestJson = {
	/**
	 * ID of the suite.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.DeleteSuiteRequest.
 * Use `create(DeleteSuiteRequestSchema)` to create a new message.
 */
export const DeleteSuiteRequestSchema: GenMessage<DeleteSuiteRequest, { jsonType: DeleteSuiteRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 56);

/**
 * @generated from message bundles.v1.DeleteSuiteResponse
 */
export type DeleteSuiteResponse = Message<"bundles.v1.DeleteSuiteResponse"> & {};

/**
 * @generated from message bundles.v1.DeleteSuiteResponse
 */
export type DeleteSuiteResponseJson = {};

/**
 * Describes the message bundles.v1.DeleteSuiteResponse.
 * Use `create(DeleteSuiteResponseSchema)` to create a new message.
 */
export const DeleteSuiteResponseSchema: GenMessage<DeleteSuiteResponse, { jsonType: DeleteSuiteResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 57);

/**
 * @generated from message bundles.v1.BulkDeleteSuiteRequest
 */
export type BulkDeleteSuiteRequest = Message<"bundles.v1.BulkDeleteSuiteRequest"> & {
	/**
	 * @generated from field: repeated bundles.v1.DeleteSuiteRequest requests = 1;
	 */
	requests: DeleteSuiteRequest[];
};

/**
 * @generated from message bundles.v1.BulkDeleteSuiteRequest
 */
export type BulkDeleteSuiteRequestJson = {
	/**
	 * @generated from field: repeated bundles.v1.DeleteSuiteRequest requests = 1;
	 */
	requests?: DeleteSuiteRequestJson[];
};

/**
 * Describes the message bundles.v1.BulkDeleteSuiteRequest.
 * Use `create(BulkDeleteSuiteRequestSchema)` to create a new message.
 */
export const BulkDeleteSuiteRequestSchema: GenMessage<BulkDeleteSuiteRequest, { jsonType: BulkDeleteSuiteRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 58);

/**
 * @generated from message bundles.v1.BulkDeleteSuiteResponse
 */
export type BulkDeleteSuiteResponse = Message<"bundles.v1.BulkDeleteSuiteResponse"> & {
	/**
	 * @generated from field: bundles.v1.DeleteSuiteResponse response = 1;
	 */
	response?: DeleteSuiteResponse | undefined;

	/**
	 * @generated from field: google.rpc.Status status = 2;
	 */
	status?: Status | undefined;
};

/**
 * @generated from message bundles.v1.BulkDeleteSuiteResponse
 */
export type BulkDeleteSuiteResponseJson = {
	/**
	 * @generated from field: bundles.v1.DeleteSuiteResponse response = 1;
	 */
	response?: DeleteSuiteResponseJson;

	/**
	 * @generated from field: google.rpc.Status status = 2;
	 */
	status?: StatusJson;
};

/**
 * Describes the message bundles.v1.BulkDeleteSuiteResponse.
 * Use `create(BulkDeleteSuiteResponseSchema)` to create a new message.
 */
export const BulkDeleteSuiteResponseSchema: GenMessage<BulkDeleteSuiteResponse, { jsonType: BulkDeleteSuiteResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 59);

/**
 * @generated from message bundles.v1.LoadRequest
 */
export type LoadRequest = Message<"bundles.v1.LoadRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 7;
	 */
	version: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 3;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * @generated from field: bundles.v1.Mode mode = 4;
	 */
	mode: Mode;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 5;
	 */
	mlMetadata?: ConversionMetaData | undefined;

	/**
	 * @generated from field: bundles.v1.GeoLocation geolocation = 6;
	 */
	geolocation?: GeoLocation | undefined;
};

/**
 * @generated from message bundles.v1.LoadRequest
 */
export type LoadRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 7;
	 */
	version?: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 3;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * @generated from field: bundles.v1.Mode mode = 4;
	 */
	mode?: ModeJson;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 5;
	 */
	mlMetadata?: ConversionMetaDataJson;

	/**
	 * @generated from field: bundles.v1.GeoLocation geolocation = 6;
	 */
	geolocation?: GeoLocationJson;
};

/**
 * Describes the message bundles.v1.LoadRequest.
 * Use `create(LoadRequestSchema)` to create a new message.
 */
export const LoadRequestSchema: GenMessage<LoadRequest, { jsonType: LoadRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 60);

/**
 * @generated from message bundles.v1.LoadResponse
 */
export type LoadResponse = Message<"bundles.v1.LoadResponse"> & {
	/**
	 * @generated from field: bundles.v1.Asset asset = 1;
	 */
	asset?: Asset | undefined;

	/**
	 * @generated from field: google.protobuf.Struct data = 2;
	 */
	data?: JsonObject | undefined;
};

/**
 * @generated from message bundles.v1.LoadResponse
 */
export type LoadResponseJson = {
	/**
	 * @generated from field: bundles.v1.Asset asset = 1;
	 */
	asset?: AssetJson;

	/**
	 * @generated from field: google.protobuf.Struct data = 2;
	 */
	data?: StructJson;
};

/**
 * Describes the message bundles.v1.LoadResponse.
 * Use `create(LoadResponseSchema)` to create a new message.
 */
export const LoadResponseSchema: GenMessage<LoadResponse, { jsonType: LoadResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 61);

/**
 * @generated from message bundles.v1.PreloadRequest
 */
export type PreloadRequest = Message<"bundles.v1.PreloadRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 7;
	 */
	version: string;

	/**
	 * @generated from field: repeated string keys = 2;
	 */
	keys: string[];

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 3;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * @generated from field: bundles.v1.Mode mode = 4;
	 */
	mode: Mode;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 5;
	 */
	mlMetadata?: ConversionMetaData | undefined;

	/**
	 * @generated from field: bundles.v1.GeoLocation geolocation = 6;
	 */
	geolocation?: GeoLocation | undefined;

	/**
	 * @generated from field: bundles.v1.RequestIntent intent = 8;
	 */
	intent: RequestIntent;
};

/**
 * @generated from message bundles.v1.PreloadRequest
 */
export type PreloadRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 7;
	 */
	version?: string;

	/**
	 * @generated from field: repeated string keys = 2;
	 */
	keys?: string[];

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 3;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * @generated from field: bundles.v1.Mode mode = 4;
	 */
	mode?: ModeJson;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 5;
	 */
	mlMetadata?: ConversionMetaDataJson;

	/**
	 * @generated from field: bundles.v1.GeoLocation geolocation = 6;
	 */
	geolocation?: GeoLocationJson;

	/**
	 * @generated from field: bundles.v1.RequestIntent intent = 8;
	 */
	intent?: RequestIntentJson;
};

/**
 * Describes the message bundles.v1.PreloadRequest.
 * Use `create(PreloadRequestSchema)` to create a new message.
 */
export const PreloadRequestSchema: GenMessage<PreloadRequest, { jsonType: PreloadRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 62);

/**
 * @generated from message bundles.v1.PartialError
 */
export type PartialError = Message<"bundles.v1.PartialError"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * @generated from field: google.rpc.Status error = 2;
	 */
	error?: Status | undefined;
};

/**
 * @generated from message bundles.v1.PartialError
 */
export type PartialErrorJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * @generated from field: google.rpc.Status error = 2;
	 */
	error?: StatusJson;
};

/**
 * Describes the message bundles.v1.PartialError.
 * Use `create(PartialErrorSchema)` to create a new message.
 */
export const PartialErrorSchema: GenMessage<PartialError, { jsonType: PartialErrorJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 63);

/**
 * @generated from message bundles.v1.PreloadResponse
 */
export type PreloadResponse = Message<"bundles.v1.PreloadResponse"> & {
	/**
	 * @generated from oneof bundles.v1.PreloadResponse.result
	 */
	result:
		| {
				/**
				 * @generated from field: bundles.v1.LoadResponse response = 1;
				 */
				value: LoadResponse;
				case: "response";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.PartialError error = 2;
				 */
				value: PartialError;
				case: "error";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message bundles.v1.PreloadResponse
 */
export type PreloadResponseJson = {
	/**
	 * @generated from field: bundles.v1.LoadResponse response = 1;
	 */
	response?: LoadResponseJson;

	/**
	 * @generated from field: bundles.v1.PartialError error = 2;
	 */
	error?: PartialErrorJson;
};

/**
 * Describes the message bundles.v1.PreloadResponse.
 * Use `create(PreloadResponseSchema)` to create a new message.
 */
export const PreloadResponseSchema: GenMessage<PreloadResponse, { jsonType: PreloadResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 64);

/**
 * @generated from message bundles.v1.EditRequest
 */
export type EditRequest = Message<"bundles.v1.EditRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string key = 3;
	 */
	key: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 4;
	 */
	entryPoint?: EntryPoint | undefined;
};

/**
 * @generated from message bundles.v1.EditRequest
 */
export type EditRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string key = 3;
	 */
	key?: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 4;
	 */
	entryPoint?: EntryPointJson;
};

/**
 * Describes the message bundles.v1.EditRequest.
 * Use `create(EditRequestSchema)` to create a new message.
 */
export const EditRequestSchema: GenMessage<EditRequest, { jsonType: EditRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 65);

/**
 * @generated from message bundles.v1.EditResponse
 */
export type EditResponse = Message<"bundles.v1.EditResponse"> & {
	/**
	 * @generated from field: bundles.v1.Asset asset = 1;
	 */
	asset?: Asset | undefined;

	/**
	 * @generated from field: google.protobuf.Struct data = 2;
	 */
	data?: JsonObject | undefined;
};

/**
 * @generated from message bundles.v1.EditResponse
 */
export type EditResponseJson = {
	/**
	 * @generated from field: bundles.v1.Asset asset = 1;
	 */
	asset?: AssetJson;

	/**
	 * @generated from field: google.protobuf.Struct data = 2;
	 */
	data?: StructJson;
};

/**
 * Describes the message bundles.v1.EditResponse.
 * Use `create(EditResponseSchema)` to create a new message.
 */
export const EditResponseSchema: GenMessage<EditResponse, { jsonType: EditResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 66);

/**
 * @generated from message bundles.v1.EditPreloadRequest
 */
export type EditPreloadRequest = Message<"bundles.v1.EditPreloadRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: repeated string keys = 3;
	 */
	keys: string[];

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 4;
	 */
	entryPoint?: EntryPoint | undefined;
};

/**
 * @generated from message bundles.v1.EditPreloadRequest
 */
export type EditPreloadRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: repeated string keys = 3;
	 */
	keys?: string[];

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 4;
	 */
	entryPoint?: EntryPointJson;
};

/**
 * Describes the message bundles.v1.EditPreloadRequest.
 * Use `create(EditPreloadRequestSchema)` to create a new message.
 */
export const EditPreloadRequestSchema: GenMessage<EditPreloadRequest, { jsonType: EditPreloadRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 67);

/**
 * @generated from message bundles.v1.EditPreloadResponse
 */
export type EditPreloadResponse = Message<"bundles.v1.EditPreloadResponse"> & {
	/**
	 * @generated from oneof bundles.v1.EditPreloadResponse.result
	 */
	result:
		| {
				/**
				 * @generated from field: bundles.v1.EditResponse response = 1;
				 */
				value: EditResponse;
				case: "response";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.PartialError error = 2;
				 */
				value: PartialError;
				case: "error";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message bundles.v1.EditPreloadResponse
 */
export type EditPreloadResponseJson = {
	/**
	 * @generated from field: bundles.v1.EditResponse response = 1;
	 */
	response?: EditResponseJson;

	/**
	 * @generated from field: bundles.v1.PartialError error = 2;
	 */
	error?: PartialErrorJson;
};

/**
 * Describes the message bundles.v1.EditPreloadResponse.
 * Use `create(EditPreloadResponseSchema)` to create a new message.
 */
export const EditPreloadResponseSchema: GenMessage<EditPreloadResponse, { jsonType: EditPreloadResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 68);

/**
 * @generated from message bundles.v1.RenderStringsRequest
 */
export type RenderStringsRequest = Message<"bundles.v1.RenderStringsRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 4;
	 */
	version: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 2;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * @generated from field: repeated string to_render = 3;
	 */
	toRender: string[];
};

/**
 * @generated from message bundles.v1.RenderStringsRequest
 */
export type RenderStringsRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 4;
	 */
	version?: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 2;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * @generated from field: repeated string to_render = 3;
	 */
	toRender?: string[];
};

/**
 * Describes the message bundles.v1.RenderStringsRequest.
 * Use `create(RenderStringsRequestSchema)` to create a new message.
 */
export const RenderStringsRequestSchema: GenMessage<RenderStringsRequest, { jsonType: RenderStringsRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 69);

/**
 * @generated from message bundles.v1.RenderStringsResponse
 */
export type RenderStringsResponse = Message<"bundles.v1.RenderStringsResponse"> & {
	/**
	 * @generated from field: repeated string rendered = 1;
	 */
	rendered: string[];
};

/**
 * @generated from message bundles.v1.RenderStringsResponse
 */
export type RenderStringsResponseJson = {
	/**
	 * @generated from field: repeated string rendered = 1;
	 */
	rendered?: string[];
};

/**
 * Describes the message bundles.v1.RenderStringsResponse.
 * Use `create(RenderStringsResponseSchema)` to create a new message.
 */
export const RenderStringsResponseSchema: GenMessage<RenderStringsResponse, { jsonType: RenderStringsResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 70);

/**
 * @generated from message bundles.v1.RenderStructRequest
 */
export type RenderStructRequest = Message<"bundles.v1.RenderStructRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 5;
	 */
	version: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 2;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * @generated from field: google.protobuf.Struct to_render = 3;
	 */
	toRender?: JsonObject | undefined;

	/**
	 * @generated from field: optional bundles.v1.Data data = 4;
	 */
	data?: Data | undefined;
};

/**
 * @generated from message bundles.v1.RenderStructRequest
 */
export type RenderStructRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 5;
	 */
	version?: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 2;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * @generated from field: google.protobuf.Struct to_render = 3;
	 */
	toRender?: StructJson;

	/**
	 * @generated from field: optional bundles.v1.Data data = 4;
	 */
	data?: DataJson;
};

/**
 * Describes the message bundles.v1.RenderStructRequest.
 * Use `create(RenderStructRequestSchema)` to create a new message.
 */
export const RenderStructRequestSchema: GenMessage<RenderStructRequest, { jsonType: RenderStructRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 71);

/**
 * @generated from message bundles.v1.RenderStructResponse
 */
export type RenderStructResponse = Message<"bundles.v1.RenderStructResponse"> & {
	/**
	 * @generated from field: google.protobuf.Struct rendered = 1;
	 */
	rendered?: JsonObject | undefined;
};

/**
 * @generated from message bundles.v1.RenderStructResponse
 */
export type RenderStructResponseJson = {
	/**
	 * @generated from field: google.protobuf.Struct rendered = 1;
	 */
	rendered?: StructJson;
};

/**
 * Describes the message bundles.v1.RenderStructResponse.
 * Use `create(RenderStructResponseSchema)` to create a new message.
 */
export const RenderStructResponseSchema: GenMessage<RenderStructResponse, { jsonType: RenderStructResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 72);

/**
 * @generated from message bundles.v1.SaveRequest
 */
export type SaveRequest = Message<"bundles.v1.SaveRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 5;
	 */
	version: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * @generated from field: google.protobuf.Struct data = 4;
	 */
	data?: JsonObject | undefined;

	/**
	 * @generated from field: bundles.v1.Asset asset = 6;
	 */
	asset?: Asset | undefined;
};

/**
 * @generated from message bundles.v1.SaveRequest
 */
export type SaveRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 5;
	 */
	version?: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * @generated from field: google.protobuf.Struct data = 4;
	 */
	data?: StructJson;

	/**
	 * @generated from field: bundles.v1.Asset asset = 6;
	 */
	asset?: AssetJson;
};

/**
 * Describes the message bundles.v1.SaveRequest.
 * Use `create(SaveRequestSchema)` to create a new message.
 */
export const SaveRequestSchema: GenMessage<SaveRequest, { jsonType: SaveRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 73);

/**
 * @generated from message bundles.v1.SaveResponse
 */
export type SaveResponse = Message<"bundles.v1.SaveResponse"> & {
	/**
	 * @generated from field: bundles.v1.Asset asset = 1;
	 */
	asset?: Asset | undefined;

	/**
	 * @generated from field: google.protobuf.Struct data = 2;
	 */
	data?: JsonObject | undefined;
};

/**
 * @generated from message bundles.v1.SaveResponse
 */
export type SaveResponseJson = {
	/**
	 * @generated from field: bundles.v1.Asset asset = 1;
	 */
	asset?: AssetJson;

	/**
	 * @generated from field: google.protobuf.Struct data = 2;
	 */
	data?: StructJson;
};

/**
 * Describes the message bundles.v1.SaveResponse.
 * Use `create(SaveResponseSchema)` to create a new message.
 */
export const SaveResponseSchema: GenMessage<SaveResponse, { jsonType: SaveResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 74);

/**
 * @generated from message bundles.v1.ExecuteRequest
 */
export type ExecuteRequest = Message<"bundles.v1.ExecuteRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 8;
	 */
	version: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 3;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * @generated from field: google.protobuf.Struct data = 4;
	 */
	data?: JsonObject | undefined;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData metadata = 5;
	 */
	metadata?: ConversionMetaData | undefined;

	/**
	 * @generated from field: bundles.v1.Mode mode = 6;
	 */
	mode: Mode;

	/**
	 * @generated from field: bundles.v1.GeoLocation geolocation = 7;
	 */
	geolocation?: GeoLocation | undefined;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 10;
	 */
	conversionType: ConversionType;

	/**
	 * @generated from field: string conversion_component = 11;
	 */
	conversionComponent: string;

	/**
	 * @generated from field: bundles.v1.RequestIntent intent = 12;
	 */
	intent: RequestIntent;

	/**
	 * Optional component ID of the button/element that triggered execution.
	 *
	 * @generated from field: optional string source_anchor = 9 [deprecated = true];
	 * @deprecated
	 */
	sourceAnchor?: string | undefined;
};

/**
 * @generated from message bundles.v1.ExecuteRequest
 */
export type ExecuteRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 8;
	 */
	version?: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 3;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * @generated from field: google.protobuf.Struct data = 4;
	 */
	data?: StructJson;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData metadata = 5;
	 */
	metadata?: ConversionMetaDataJson;

	/**
	 * @generated from field: bundles.v1.Mode mode = 6;
	 */
	mode?: ModeJson;

	/**
	 * @generated from field: bundles.v1.GeoLocation geolocation = 7;
	 */
	geolocation?: GeoLocationJson;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 10;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * @generated from field: string conversion_component = 11;
	 */
	conversionComponent?: string;

	/**
	 * @generated from field: bundles.v1.RequestIntent intent = 12;
	 */
	intent?: RequestIntentJson;

	/**
	 * Optional component ID of the button/element that triggered execution.
	 *
	 * @generated from field: optional string source_anchor = 9 [deprecated = true];
	 * @deprecated
	 */
	sourceAnchor?: string;
};

/**
 * Describes the message bundles.v1.ExecuteRequest.
 * Use `create(ExecuteRequestSchema)` to create a new message.
 */
export const ExecuteRequestSchema: GenMessage<ExecuteRequest, { jsonType: ExecuteRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 75);

/**
 * @generated from message bundles.v1.ExecuteResponse
 */
export type ExecuteResponse = Message<"bundles.v1.ExecuteResponse"> & {
	/**
	 * @generated from field: bundles.v1.Destination destination = 1;
	 */
	destination?: Destination | undefined;

	/**
	 * @generated from field: google.protobuf.Struct data = 2;
	 */
	data?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Struct result = 3;
	 */
	result?: JsonObject | undefined;
};

/**
 * @generated from message bundles.v1.ExecuteResponse
 */
export type ExecuteResponseJson = {
	/**
	 * @generated from field: bundles.v1.Destination destination = 1;
	 */
	destination?: DestinationJson;

	/**
	 * @generated from field: google.protobuf.Struct data = 2;
	 */
	data?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct result = 3;
	 */
	result?: StructJson;
};

/**
 * Describes the message bundles.v1.ExecuteResponse.
 * Use `create(ExecuteResponseSchema)` to create a new message.
 */
export const ExecuteResponseSchema: GenMessage<ExecuteResponse, { jsonType: ExecuteResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 76);

/**
 * @generated from message bundles.v1.CancelRequest
 */
export type CancelRequest = Message<"bundles.v1.CancelRequest"> & {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: string version = 7;
	 */
	version: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 4;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData metadata = 3;
	 */
	metadata?: ConversionMetaData | undefined;

	/**
	 * @generated from field: bundles.v1.Mode mode = 5;
	 */
	mode: Mode;

	/**
	 * @generated from field: bundles.v1.GeoLocation geolocation = 6;
	 */
	geolocation?: GeoLocation | undefined;
};

/**
 * @generated from message bundles.v1.CancelRequest
 */
export type CancelRequestJson = {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string version = 7;
	 */
	version?: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 4;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData metadata = 3;
	 */
	metadata?: ConversionMetaDataJson;

	/**
	 * @generated from field: bundles.v1.Mode mode = 5;
	 */
	mode?: ModeJson;

	/**
	 * @generated from field: bundles.v1.GeoLocation geolocation = 6;
	 */
	geolocation?: GeoLocationJson;
};

/**
 * Describes the message bundles.v1.CancelRequest.
 * Use `create(CancelRequestSchema)` to create a new message.
 */
export const CancelRequestSchema: GenMessage<CancelRequest, { jsonType: CancelRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 77);

/**
 * @generated from message bundles.v1.CancelResponse
 */
export type CancelResponse = Message<"bundles.v1.CancelResponse"> & {};

/**
 * @generated from message bundles.v1.CancelResponse
 */
export type CancelResponseJson = {};

/**
 * Describes the message bundles.v1.CancelResponse.
 * Use `create(CancelResponseSchema)` to create a new message.
 */
export const CancelResponseSchema: GenMessage<CancelResponse, { jsonType: CancelResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 78);

/**
 * @generated from message bundles.v1.ExitRequest
 */
export type ExitRequest = Message<"bundles.v1.ExitRequest"> & {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: string version = 7;
	 */
	version: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 4;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData metadata = 3;
	 */
	metadata?: ConversionMetaData | undefined;

	/**
	 * @generated from field: bundles.v1.Mode mode = 5;
	 */
	mode: Mode;

	/**
	 * @generated from field: bundles.v1.GeoLocation geolocation = 6;
	 */
	geolocation?: GeoLocation | undefined;
};

/**
 * @generated from message bundles.v1.ExitRequest
 */
export type ExitRequestJson = {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string version = 7;
	 */
	version?: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 4;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData metadata = 3;
	 */
	metadata?: ConversionMetaDataJson;

	/**
	 * @generated from field: bundles.v1.Mode mode = 5;
	 */
	mode?: ModeJson;

	/**
	 * @generated from field: bundles.v1.GeoLocation geolocation = 6;
	 */
	geolocation?: GeoLocationJson;
};

/**
 * Describes the message bundles.v1.ExitRequest.
 * Use `create(ExitRequestSchema)` to create a new message.
 */
export const ExitRequestSchema: GenMessage<ExitRequest, { jsonType: ExitRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 79);

/**
 * @generated from message bundles.v1.ExitResponse
 */
export type ExitResponse = Message<"bundles.v1.ExitResponse"> & {};

/**
 * @generated from message bundles.v1.ExitResponse
 */
export type ExitResponseJson = {};

/**
 * Describes the message bundles.v1.ExitResponse.
 * Use `create(ExitResponseSchema)` to create a new message.
 */
export const ExitResponseSchema: GenMessage<ExitResponse, { jsonType: ExitResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 80);

/**
 * @generated from message bundles.v1.GetModuleRequest
 */
export type GetModuleRequest = Message<"bundles.v1.GetModuleRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message bundles.v1.GetModuleRequest
 */
export type GetModuleRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.GetModuleRequest.
 * Use `create(GetModuleRequestSchema)` to create a new message.
 */
export const GetModuleRequestSchema: GenMessage<GetModuleRequest, { jsonType: GetModuleRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 81);

/**
 * @generated from message bundles.v1.GetModuleResponse
 */
export type GetModuleResponse = Message<"bundles.v1.GetModuleResponse"> & {
	/**
	 * @generated from field: bundles.v1.Module module = 1;
	 */
	module?: Module | undefined;
};

/**
 * @generated from message bundles.v1.GetModuleResponse
 */
export type GetModuleResponseJson = {
	/**
	 * @generated from field: bundles.v1.Module module = 1;
	 */
	module?: ModuleJson;
};

/**
 * Describes the message bundles.v1.GetModuleResponse.
 * Use `create(GetModuleResponseSchema)` to create a new message.
 */
export const GetModuleResponseSchema: GenMessage<GetModuleResponse, { jsonType: GetModuleResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 82);

/**
 * @generated from message bundles.v1.GetModulesInSuiteRequest
 */
export type GetModulesInSuiteRequest = Message<"bundles.v1.GetModulesInSuiteRequest"> & {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message bundles.v1.GetModulesInSuiteRequest
 */
export type GetModulesInSuiteRequestJson = {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.GetModulesInSuiteRequest.
 * Use `create(GetModulesInSuiteRequestSchema)` to create a new message.
 */
export const GetModulesInSuiteRequestSchema: GenMessage<GetModulesInSuiteRequest, { jsonType: GetModulesInSuiteRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 83);

/**
 * @generated from message bundles.v1.GetModulesInSuiteResponse
 */
export type GetModulesInSuiteResponse = Message<"bundles.v1.GetModulesInSuiteResponse"> & {
	/**
	 * @generated from field: map<string, bundles.v1.Module> modules = 1;
	 */
	modules: { [key: string]: Module };
};

/**
 * @generated from message bundles.v1.GetModulesInSuiteResponse
 */
export type GetModulesInSuiteResponseJson = {
	/**
	 * @generated from field: map<string, bundles.v1.Module> modules = 1;
	 */
	modules?: { [key: string]: ModuleJson };
};

/**
 * Describes the message bundles.v1.GetModulesInSuiteResponse.
 * Use `create(GetModulesInSuiteResponseSchema)` to create a new message.
 */
export const GetModulesInSuiteResponseSchema: GenMessage<GetModulesInSuiteResponse, { jsonType: GetModulesInSuiteResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 84);

/**
 * @generated from message bundles.v1.GetReferencedSuitesRequest
 */
export type GetReferencedSuitesRequest = Message<"bundles.v1.GetReferencedSuitesRequest"> & {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message bundles.v1.GetReferencedSuitesRequest
 */
export type GetReferencedSuitesRequestJson = {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.GetReferencedSuitesRequest.
 * Use `create(GetReferencedSuitesRequestSchema)` to create a new message.
 */
export const GetReferencedSuitesRequestSchema: GenMessage<GetReferencedSuitesRequest, { jsonType: GetReferencedSuitesRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 85);

/**
 * @generated from message bundles.v1.GetReferencedSuitesResponse
 */
export type GetReferencedSuitesResponse = Message<"bundles.v1.GetReferencedSuitesResponse"> & {
	/**
	 * @generated from field: map<string, bundles.v1.Suite> suites = 1;
	 */
	suites: { [key: string]: Suite };
};

/**
 * @generated from message bundles.v1.GetReferencedSuitesResponse
 */
export type GetReferencedSuitesResponseJson = {
	/**
	 * @generated from field: map<string, bundles.v1.Suite> suites = 1;
	 */
	suites?: { [key: string]: SuiteJson };
};

/**
 * Describes the message bundles.v1.GetReferencedSuitesResponse.
 * Use `create(GetReferencedSuitesResponseSchema)` to create a new message.
 */
export const GetReferencedSuitesResponseSchema: GenMessage<GetReferencedSuitesResponse, { jsonType: GetReferencedSuitesResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 86);

/**
 * @generated from message bundles.v1.CreateModuleRequest
 */
export type CreateModuleRequest = Message<"bundles.v1.CreateModuleRequest"> & {
	/**
	 * The id of the module template this module will be created from
	 *
	 * @generated from field: string template_id = 1;
	 */
	templateId: string;

	/**
	 * The version of the module template this module will be created from
	 *
	 * @generated from field: string template_version = 2;
	 */
	templateVersion: string;

	/**
	 * The id of the suite this module is for
	 *
	 * @generated from field: string suite_id = 3;
	 */
	suiteId: string;

	/**
	 * The version of the suite this module is for
	 *
	 * @generated from field: string suite_version = 4;
	 */
	suiteVersion: string;

	/**
	 * The name of the module
	 *
	 * @generated from field: string name = 5;
	 */
	name: string;

	/**
	 * The state of the module (e.g., "active", "draft"), if unset it will default to the state of the suite
	 *
	 * @generated from field: optional string state = 8;
	 */
	state?: string | undefined;

	/**
	 * An optional description of the module
	 *
	 * @generated from field: optional string description = 6;
	 */
	description?: string | undefined;

	/**
	 * Config is a map containing asset-specific configurations, inferred from the bundle structure.
	 *
	 * @generated from field: map<string, google.protobuf.Struct> config = 7;
	 */
	config: { [key: string]: JsonObject };
};

/**
 * @generated from message bundles.v1.CreateModuleRequest
 */
export type CreateModuleRequestJson = {
	/**
	 * The id of the module template this module will be created from
	 *
	 * @generated from field: string template_id = 1;
	 */
	templateId?: string;

	/**
	 * The version of the module template this module will be created from
	 *
	 * @generated from field: string template_version = 2;
	 */
	templateVersion?: string;

	/**
	 * The id of the suite this module is for
	 *
	 * @generated from field: string suite_id = 3;
	 */
	suiteId?: string;

	/**
	 * The version of the suite this module is for
	 *
	 * @generated from field: string suite_version = 4;
	 */
	suiteVersion?: string;

	/**
	 * The name of the module
	 *
	 * @generated from field: string name = 5;
	 */
	name?: string;

	/**
	 * The state of the module (e.g., "active", "draft"), if unset it will default to the state of the suite
	 *
	 * @generated from field: optional string state = 8;
	 */
	state?: string;

	/**
	 * An optional description of the module
	 *
	 * @generated from field: optional string description = 6;
	 */
	description?: string;

	/**
	 * Config is a map containing asset-specific configurations, inferred from the bundle structure.
	 *
	 * @generated from field: map<string, google.protobuf.Struct> config = 7;
	 */
	config?: { [key: string]: StructJson };
};

/**
 * Describes the message bundles.v1.CreateModuleRequest.
 * Use `create(CreateModuleRequestSchema)` to create a new message.
 */
export const CreateModuleRequestSchema: GenMessage<CreateModuleRequest, { jsonType: CreateModuleRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 87);

/**
 * @generated from message bundles.v1.CreateModuleResponse
 */
export type CreateModuleResponse = Message<"bundles.v1.CreateModuleResponse"> & {
	/**
	 * @generated from field: bundles.v1.Module module = 1;
	 */
	module?: Module | undefined;
};

/**
 * @generated from message bundles.v1.CreateModuleResponse
 */
export type CreateModuleResponseJson = {
	/**
	 * @generated from field: bundles.v1.Module module = 1;
	 */
	module?: ModuleJson;
};

/**
 * Describes the message bundles.v1.CreateModuleResponse.
 * Use `create(CreateModuleResponseSchema)` to create a new message.
 */
export const CreateModuleResponseSchema: GenMessage<CreateModuleResponse, { jsonType: CreateModuleResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 88);

/**
 * @generated from message bundles.v1.UpdateModuleRequest
 */
export type UpdateModuleRequest = Message<"bundles.v1.UpdateModuleRequest"> & {
	/**
	 * @generated from field: bundles.v1.Module module = 1;
	 */
	module?: Module | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message bundles.v1.UpdateModuleRequest
 */
export type UpdateModuleRequestJson = {
	/**
	 * @generated from field: bundles.v1.Module module = 1;
	 */
	module?: ModuleJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message bundles.v1.UpdateModuleRequest.
 * Use `create(UpdateModuleRequestSchema)` to create a new message.
 */
export const UpdateModuleRequestSchema: GenMessage<UpdateModuleRequest, { jsonType: UpdateModuleRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 89);

/**
 * @generated from message bundles.v1.UpdateModuleResponse
 */
export type UpdateModuleResponse = Message<"bundles.v1.UpdateModuleResponse"> & {
	/**
	 * @generated from field: bundles.v1.Module module = 1;
	 */
	module?: Module | undefined;
};

/**
 * @generated from message bundles.v1.UpdateModuleResponse
 */
export type UpdateModuleResponseJson = {
	/**
	 * @generated from field: bundles.v1.Module module = 1;
	 */
	module?: ModuleJson;
};

/**
 * Describes the message bundles.v1.UpdateModuleResponse.
 * Use `create(UpdateModuleResponseSchema)` to create a new message.
 */
export const UpdateModuleResponseSchema: GenMessage<UpdateModuleResponse, { jsonType: UpdateModuleResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 90);

/**
 * @generated from message bundles.v1.ListModuleTemplatesRequest
 */
export type ListModuleTemplatesRequest = Message<"bundles.v1.ListModuleTemplatesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * @generated from field: string name_prefix = 4;
	 */
	namePrefix: string;

	/**
	 * @generated from field: repeated string tags = 5;
	 */
	tags: string[];

	/**
	 * @generated from field: repeated string states = 6;
	 */
	states: string[];

	/**
	 * @generated from field: repeated string visibilities = 7;
	 */
	visibilities: string[];

	/**
	 * @generated from field: repeated string categories = 8;
	 */
	categories: string[];

	/**
	 * @generated from field: repeated string creator_ids = 9;
	 */
	creatorIds: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 10;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message bundles.v1.ListModuleTemplatesRequest
 */
export type ListModuleTemplatesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string name_prefix = 4;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: repeated string tags = 5;
	 */
	tags?: string[];

	/**
	 * @generated from field: repeated string states = 6;
	 */
	states?: string[];

	/**
	 * @generated from field: repeated string visibilities = 7;
	 */
	visibilities?: string[];

	/**
	 * @generated from field: repeated string categories = 8;
	 */
	categories?: string[];

	/**
	 * @generated from field: repeated string creator_ids = 9;
	 */
	creatorIds?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 10;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message bundles.v1.ListModuleTemplatesRequest.
 * Use `create(ListModuleTemplatesRequestSchema)` to create a new message.
 */
export const ListModuleTemplatesRequestSchema: GenMessage<ListModuleTemplatesRequest, { jsonType: ListModuleTemplatesRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 91);

/**
 * @generated from message bundles.v1.ListModuleTemplatesResponse
 */
export type ListModuleTemplatesResponse = Message<"bundles.v1.ListModuleTemplatesResponse"> & {
	/**
	 * @generated from field: repeated bundles.v1.ModuleTemplate templates = 1;
	 */
	templates: ModuleTemplate[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message bundles.v1.ListModuleTemplatesResponse
 */
export type ListModuleTemplatesResponseJson = {
	/**
	 * @generated from field: repeated bundles.v1.ModuleTemplate templates = 1;
	 */
	templates?: ModuleTemplateJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message bundles.v1.ListModuleTemplatesResponse.
 * Use `create(ListModuleTemplatesResponseSchema)` to create a new message.
 */
export const ListModuleTemplatesResponseSchema: GenMessage<ListModuleTemplatesResponse, { jsonType: ListModuleTemplatesResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 92);

/**
 * @generated from message bundles.v1.GetModuleTemplateRequest
 */
export type GetModuleTemplateRequest = Message<"bundles.v1.GetModuleTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message bundles.v1.GetModuleTemplateRequest
 */
export type GetModuleTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.GetModuleTemplateRequest.
 * Use `create(GetModuleTemplateRequestSchema)` to create a new message.
 */
export const GetModuleTemplateRequestSchema: GenMessage<GetModuleTemplateRequest, { jsonType: GetModuleTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 93);

/**
 * @generated from message bundles.v1.GetModuleTemplateResponse
 */
export type GetModuleTemplateResponse = Message<"bundles.v1.GetModuleTemplateResponse"> & {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplate | undefined;
};

/**
 * @generated from message bundles.v1.GetModuleTemplateResponse
 */
export type GetModuleTemplateResponseJson = {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplateJson;
};

/**
 * Describes the message bundles.v1.GetModuleTemplateResponse.
 * Use `create(GetModuleTemplateResponseSchema)` to create a new message.
 */
export const GetModuleTemplateResponseSchema: GenMessage<GetModuleTemplateResponse, { jsonType: GetModuleTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 94);

/**
 * @generated from message bundles.v1.CreateModuleTemplateRequest
 */
export type CreateModuleTemplateRequest = Message<"bundles.v1.CreateModuleTemplateRequest"> & {
	/**
	 * @generated from field: string dag_version = 1;
	 */
	dagVersion: string;

	/**
	 * @generated from field: repeated bundles.v1.BundleType supported_bundle_types = 2;
	 */
	supportedBundleTypes: BundleType[];

	/**
	 * @generated from field: string category = 3;
	 */
	category: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string name = 6;
	 */
	name: string;

	/**
	 * @generated from field: optional string description = 7;
	 */
	description?: string | undefined;

	/**
	 * @generated from field: string folder_path = 8;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 9;
	 */
	tags: string[];

	/**
	 * @generated from field: string visibility = 10;
	 */
	visibility: string;

	/**
	 * @generated from field: map<string, bundles.v1.TemplateRef> templates = 11;
	 */
	templates: { [key: string]: TemplateRef };

	/**
	 * @generated from field: repeated bundles.v1.Link links = 12;
	 */
	links: Link[];

	/**
	 * @generated from field: string entry_point = 13;
	 */
	entryPoint: string;

	/**
	 * @generated from field: string config_schema = 14;
	 */
	configSchema: string;

	/**
	 * @generated from field: string icon_url = 16;
	 */
	iconUrl: string;

	/**
	 * @generated from field: repeated bundles.v1.RenderMode supported_render_modes = 15;
	 */
	supportedRenderModes: RenderMode[];
};

/**
 * @generated from message bundles.v1.CreateModuleTemplateRequest
 */
export type CreateModuleTemplateRequestJson = {
	/**
	 * @generated from field: string dag_version = 1;
	 */
	dagVersion?: string;

	/**
	 * @generated from field: repeated bundles.v1.BundleType supported_bundle_types = 2;
	 */
	supportedBundleTypes?: BundleTypeJson[];

	/**
	 * @generated from field: string category = 3;
	 */
	category?: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string name = 6;
	 */
	name?: string;

	/**
	 * @generated from field: optional string description = 7;
	 */
	description?: string;

	/**
	 * @generated from field: string folder_path = 8;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 9;
	 */
	tags?: string[];

	/**
	 * @generated from field: string visibility = 10;
	 */
	visibility?: string;

	/**
	 * @generated from field: map<string, bundles.v1.TemplateRef> templates = 11;
	 */
	templates?: { [key: string]: TemplateRefJson };

	/**
	 * @generated from field: repeated bundles.v1.Link links = 12;
	 */
	links?: LinkJson[];

	/**
	 * @generated from field: string entry_point = 13;
	 */
	entryPoint?: string;

	/**
	 * @generated from field: string config_schema = 14;
	 */
	configSchema?: string;

	/**
	 * @generated from field: string icon_url = 16;
	 */
	iconUrl?: string;

	/**
	 * @generated from field: repeated bundles.v1.RenderMode supported_render_modes = 15;
	 */
	supportedRenderModes?: RenderModeJson[];
};

/**
 * Describes the message bundles.v1.CreateModuleTemplateRequest.
 * Use `create(CreateModuleTemplateRequestSchema)` to create a new message.
 */
export const CreateModuleTemplateRequestSchema: GenMessage<CreateModuleTemplateRequest, { jsonType: CreateModuleTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 95);

/**
 * @generated from message bundles.v1.CreateModuleTemplateResponse
 */
export type CreateModuleTemplateResponse = Message<"bundles.v1.CreateModuleTemplateResponse"> & {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplate | undefined;
};

/**
 * @generated from message bundles.v1.CreateModuleTemplateResponse
 */
export type CreateModuleTemplateResponseJson = {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplateJson;
};

/**
 * Describes the message bundles.v1.CreateModuleTemplateResponse.
 * Use `create(CreateModuleTemplateResponseSchema)` to create a new message.
 */
export const CreateModuleTemplateResponseSchema: GenMessage<CreateModuleTemplateResponse, { jsonType: CreateModuleTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 96);

/**
 * @generated from message bundles.v1.UpdateModuleTemplateRequest
 */
export type UpdateModuleTemplateRequest = Message<"bundles.v1.UpdateModuleTemplateRequest"> & {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplate | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message bundles.v1.UpdateModuleTemplateRequest
 */
export type UpdateModuleTemplateRequestJson = {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplateJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message bundles.v1.UpdateModuleTemplateRequest.
 * Use `create(UpdateModuleTemplateRequestSchema)` to create a new message.
 */
export const UpdateModuleTemplateRequestSchema: GenMessage<UpdateModuleTemplateRequest, { jsonType: UpdateModuleTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 97);

/**
 * @generated from message bundles.v1.UpdateModuleTemplateResponse
 */
export type UpdateModuleTemplateResponse = Message<"bundles.v1.UpdateModuleTemplateResponse"> & {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplate | undefined;
};

/**
 * @generated from message bundles.v1.UpdateModuleTemplateResponse
 */
export type UpdateModuleTemplateResponseJson = {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplateJson;
};

/**
 * Describes the message bundles.v1.UpdateModuleTemplateResponse.
 * Use `create(UpdateModuleTemplateResponseSchema)` to create a new message.
 */
export const UpdateModuleTemplateResponseSchema: GenMessage<UpdateModuleTemplateResponse, { jsonType: UpdateModuleTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 98);

/**
 * @generated from message bundles.v1.DeleteModuleTemplateRequest
 */
export type DeleteModuleTemplateRequest = Message<"bundles.v1.DeleteModuleTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message bundles.v1.DeleteModuleTemplateRequest
 */
export type DeleteModuleTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.DeleteModuleTemplateRequest.
 * Use `create(DeleteModuleTemplateRequestSchema)` to create a new message.
 */
export const DeleteModuleTemplateRequestSchema: GenMessage<DeleteModuleTemplateRequest, { jsonType: DeleteModuleTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 99);

/**
 * @generated from message bundles.v1.DeleteModuleTemplateResponse
 */
export type DeleteModuleTemplateResponse = Message<"bundles.v1.DeleteModuleTemplateResponse"> & {};

/**
 * @generated from message bundles.v1.DeleteModuleTemplateResponse
 */
export type DeleteModuleTemplateResponseJson = {};

/**
 * Describes the message bundles.v1.DeleteModuleTemplateResponse.
 * Use `create(DeleteModuleTemplateResponseSchema)` to create a new message.
 */
export const DeleteModuleTemplateResponseSchema: GenMessage<DeleteModuleTemplateResponse, { jsonType: DeleteModuleTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 100);

/**
 * @generated from message bundles.v1.TestCallRequest
 */
export type TestCallRequest = Message<"bundles.v1.TestCallRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string key = 3;
	 */
	key: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 4;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * @generated from field: bundles.v1.ApiLookup api_lookup = 5;
	 */
	apiLookup?: ApiLookup | undefined;
};

/**
 * @generated from message bundles.v1.TestCallRequest
 */
export type TestCallRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string key = 3;
	 */
	key?: string;

	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 4;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * @generated from field: bundles.v1.ApiLookup api_lookup = 5;
	 */
	apiLookup?: ApiLookupJson;
};

/**
 * Describes the message bundles.v1.TestCallRequest.
 * Use `create(TestCallRequestSchema)` to create a new message.
 */
export const TestCallRequestSchema: GenMessage<TestCallRequest, { jsonType: TestCallRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 101);

/**
 * @generated from message bundles.v1.TestCallResponse
 */
export type TestCallResponse = Message<"bundles.v1.TestCallResponse"> & {
	/**
	 * @generated from field: int32 status_code = 1;
	 */
	statusCode: number;

	/**
	 * @generated from field: repeated bundles.v1.Header response_headers = 2;
	 */
	responseHeaders: Header[];

	/**
	 * @generated from field: bytes response_body = 3;
	 */
	responseBody: Uint8Array;
};

/**
 * @generated from message bundles.v1.TestCallResponse
 */
export type TestCallResponseJson = {
	/**
	 * @generated from field: int32 status_code = 1;
	 */
	statusCode?: number;

	/**
	 * @generated from field: repeated bundles.v1.Header response_headers = 2;
	 */
	responseHeaders?: HeaderJson[];

	/**
	 * @generated from field: bytes response_body = 3;
	 */
	responseBody?: string;
};

/**
 * Describes the message bundles.v1.TestCallResponse.
 * Use `create(TestCallResponseSchema)` to create a new message.
 */
export const TestCallResponseSchema: GenMessage<TestCallResponse, { jsonType: TestCallResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_service, 102);

/**
 * @generated from enum bundles.v1.Mode
 */
export enum Mode {
	/**
	 * @generated from enum value: MODE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: MODE_EDITING = 1;
	 */
	EDITING = 1,

	/**
	 * @generated from enum value: MODE_PREVIEW = 2;
	 */
	PREVIEW = 2,

	/**
	 * @generated from enum value: MODE_LIVE = 3;
	 */
	LIVE = 3,

	/**
	 * @generated from enum value: MODE_RELOAD = 4;
	 */
	RELOAD = 4,
}

/**
 * @generated from enum bundles.v1.Mode
 */
export type ModeJson = "MODE_UNSPECIFIED" | "MODE_EDITING" | "MODE_PREVIEW" | "MODE_LIVE" | "MODE_RELOAD";

/**
 * Describes the enum bundles.v1.Mode.
 */
export const ModeSchema: GenEnum<Mode, ModeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_service, 0);

/**
 * RequestIntent describes why the caller is making the request, which is what
 * decides whether the assets it resolves count as viewed. Unspecified counts,
 * so callers predating this field keep their current behavior.
 *
 * @generated from enum bundles.v1.RequestIntent
 */
export enum RequestIntent {
	/**
	 * @generated from enum value: REQUEST_INTENT_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * The assets are being rendered to the visitor now.
	 *
	 * @generated from enum value: REQUEST_INTENT_DISPLAY = 1;
	 */
	DISPLAY = 1,

	/**
	 * The assets are being warmed speculatively and may never be rendered.
	 *
	 * @generated from enum value: REQUEST_INTENT_PREFETCH = 2;
	 */
	PREFETCH = 2,

	/**
	 * The request re-resolves state in the background behind a view the visitor
	 * is already looking at.
	 *
	 * @generated from enum value: REQUEST_INTENT_REFRESH = 3;
	 */
	REFRESH = 3,
}

/**
 * RequestIntent describes why the caller is making the request, which is what
 * decides whether the assets it resolves count as viewed. Unspecified counts,
 * so callers predating this field keep their current behavior.
 *
 * @generated from enum bundles.v1.RequestIntent
 */
export type RequestIntentJson = "REQUEST_INTENT_UNSPECIFIED" | "REQUEST_INTENT_DISPLAY" | "REQUEST_INTENT_PREFETCH" | "REQUEST_INTENT_REFRESH";

/**
 * Describes the enum bundles.v1.RequestIntent.
 */
export const RequestIntentSchema: GenEnum<RequestIntent, RequestIntentJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_service, 1);

/**
 * @generated from service bundles.v1.BundleService
 */
export const BundleService: GenService<{
	/**
	 * @generated from rpc bundles.v1.BundleService.CreateBundle
	 */
	createBundle: {
		methodKind: "unary";
		input: typeof CreateBundleRequestSchema;
		output: typeof CreateBundleResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.CreateBundleFromSuite
	 */
	createBundleFromSuite: {
		methodKind: "unary";
		input: typeof CreateBundleFromSuiteRequestSchema;
		output: typeof CreateBundleFromSuiteResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.ExportBundle
	 */
	exportBundle: {
		methodKind: "unary";
		input: typeof ExportBundleRequestSchema;
		output: typeof ExportBundleResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.ImportBundle
	 */
	importBundle: {
		methodKind: "unary";
		input: typeof ImportBundleRequestSchema;
		output: typeof ImportBundleResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.ListBundles
	 */
	listBundles: {
		methodKind: "unary";
		input: typeof ListBundlesRequestSchema;
		output: typeof ListBundlesResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.GetBundle
	 */
	getBundle: {
		methodKind: "unary";
		input: typeof GetBundleRequestSchema;
		output: typeof GetBundleResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.GetBundleCategories
	 */
	getBundleCategories: {
		methodKind: "unary";
		input: typeof GetBundleCategoriesRequestSchema;
		output: typeof GetBundleCategoriesResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.UpdateBundle
	 */
	updateBundle: {
		methodKind: "unary";
		input: typeof UpdateBundleRequestSchema;
		output: typeof UpdateBundleResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.DeleteBundle
	 */
	deleteBundle: {
		methodKind: "unary";
		input: typeof DeleteBundleRequestSchema;
		output: typeof DeleteBundleResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.CreateSuite
	 */
	createSuite: {
		methodKind: "unary";
		input: typeof CreateSuiteRequestSchema;
		output: typeof CreateSuiteResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.BulkImportSuites
	 */
	bulkImportSuites: {
		methodKind: "unary";
		input: typeof BulkImportSuitesRequestSchema;
		output: typeof BulkImportSuitesResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.CreateSuiteVersion
	 */
	createSuiteVersion: {
		methodKind: "unary";
		input: typeof CreateSuiteVersionRequestSchema;
		output: typeof CreateSuiteVersionResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.PublishSuiteVersion
	 */
	publishSuiteVersion: {
		methodKind: "unary";
		input: typeof PublishSuiteVersionRequestSchema;
		output: typeof PublishSuiteVersionResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.CloneSuite
	 */
	cloneSuite: {
		methodKind: "unary";
		input: typeof CloneSuiteRequestSchema;
		output: typeof CloneSuiteResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.ListSuites
	 */
	listSuites: {
		methodKind: "unary";
		input: typeof ListSuitesRequestSchema;
		output: typeof ListSuitesResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.ListSuiteVersions
	 */
	listSuiteVersions: {
		methodKind: "unary";
		input: typeof ListSuiteVersionsRequestSchema;
		output: typeof ListSuiteVersionsResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.GetSuite
	 */
	getSuite: {
		methodKind: "unary";
		input: typeof GetSuiteRequestSchema;
		output: typeof GetSuiteResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.UpdateSuite
	 */
	updateSuite: {
		methodKind: "unary";
		input: typeof UpdateSuiteRequestSchema;
		output: typeof UpdateSuiteResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.BulkUpdateSuite
	 */
	bulkUpdateSuite: {
		methodKind: "server_streaming";
		input: typeof BulkUpdateSuiteRequestSchema;
		output: typeof BulkUpdateSuiteResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.DeleteSuite
	 */
	deleteSuite: {
		methodKind: "unary";
		input: typeof DeleteSuiteRequestSchema;
		output: typeof DeleteSuiteResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.BulkDeleteSuite
	 */
	bulkDeleteSuite: {
		methodKind: "server_streaming";
		input: typeof BulkDeleteSuiteRequestSchema;
		output: typeof BulkDeleteSuiteResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.ValidateSuite
	 */
	validateSuite: {
		methodKind: "unary";
		input: typeof ValidateSuiteRequestSchema;
		output: typeof ValidateSuiteResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.Load
	 */
	load: {
		methodKind: "unary";
		input: typeof LoadRequestSchema;
		output: typeof LoadResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.Preload
	 */
	preload: {
		methodKind: "server_streaming";
		input: typeof PreloadRequestSchema;
		output: typeof PreloadResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.Edit
	 */
	edit: {
		methodKind: "unary";
		input: typeof EditRequestSchema;
		output: typeof EditResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.EditPreload
	 */
	editPreload: {
		methodKind: "server_streaming";
		input: typeof EditPreloadRequestSchema;
		output: typeof EditPreloadResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.Save
	 */
	save: {
		methodKind: "unary";
		input: typeof SaveRequestSchema;
		output: typeof SaveResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.Execute
	 */
	execute: {
		methodKind: "unary";
		input: typeof ExecuteRequestSchema;
		output: typeof ExecuteResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.Cancel
	 */
	cancel: {
		methodKind: "unary";
		input: typeof CancelRequestSchema;
		output: typeof CancelResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.Exit
	 */
	exit: {
		methodKind: "unary";
		input: typeof ExitRequestSchema;
		output: typeof ExitResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.RenderStrings
	 */
	renderStrings: {
		methodKind: "unary";
		input: typeof RenderStringsRequestSchema;
		output: typeof RenderStringsResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.RenderStruct
	 */
	renderStruct: {
		methodKind: "unary";
		input: typeof RenderStructRequestSchema;
		output: typeof RenderStructResponseSchema;
	};
	/**
	 * Versions
	 *
	 * @generated from rpc bundles.v1.BundleService.CreateBundleVersion
	 */
	createBundleVersion: {
		methodKind: "unary";
		input: typeof CreateBundleVersionRequestSchema;
		output: typeof CreateBundleVersionResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.PublishBundleVersion
	 */
	publishBundleVersion: {
		methodKind: "unary";
		input: typeof PublishBundleVersionRequestSchema;
		output: typeof PublishBundleVersionResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.ListBundleVersions
	 */
	listBundleVersions: {
		methodKind: "unary";
		input: typeof ListBundleVersionsRequestSchema;
		output: typeof ListBundleVersionsResponseSchema;
	};
	/**
	 * Module
	 *
	 * @generated from rpc bundles.v1.BundleService.CreateModule
	 */
	createModule: {
		methodKind: "unary";
		input: typeof CreateModuleRequestSchema;
		output: typeof CreateModuleResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.UpdateModule
	 */
	updateModule: {
		methodKind: "unary";
		input: typeof UpdateModuleRequestSchema;
		output: typeof UpdateModuleResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.GetModule
	 */
	getModule: {
		methodKind: "unary";
		input: typeof GetModuleRequestSchema;
		output: typeof GetModuleResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.GetModulesInSuite
	 */
	getModulesInSuite: {
		methodKind: "unary";
		input: typeof GetModulesInSuiteRequestSchema;
		output: typeof GetModulesInSuiteResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.GetReferencedSuites
	 */
	getReferencedSuites: {
		methodKind: "unary";
		input: typeof GetReferencedSuitesRequestSchema;
		output: typeof GetReferencedSuitesResponseSchema;
	};
	/**
	 * Module templates
	 *
	 * @generated from rpc bundles.v1.BundleService.CreateModuleTemplate
	 */
	createModuleTemplate: {
		methodKind: "unary";
		input: typeof CreateModuleTemplateRequestSchema;
		output: typeof CreateModuleTemplateResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.ListModuleTemplates
	 */
	listModuleTemplates: {
		methodKind: "unary";
		input: typeof ListModuleTemplatesRequestSchema;
		output: typeof ListModuleTemplatesResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.GetModuleTemplate
	 */
	getModuleTemplate: {
		methodKind: "unary";
		input: typeof GetModuleTemplateRequestSchema;
		output: typeof GetModuleTemplateResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.GetModuleTemplateCategories
	 */
	getModuleTemplateCategories: {
		methodKind: "unary";
		input: typeof GetModuleTemplateCategoriesRequestSchema;
		output: typeof GetModuleTemplateCategoriesResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.UpdateModuleTemplate
	 */
	updateModuleTemplate: {
		methodKind: "unary";
		input: typeof UpdateModuleTemplateRequestSchema;
		output: typeof UpdateModuleTemplateResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.DeleteModuleTemplate
	 */
	deleteModuleTemplate: {
		methodKind: "unary";
		input: typeof DeleteModuleTemplateRequestSchema;
		output: typeof DeleteModuleTemplateResponseSchema;
	};
	/**
	 * Versions
	 *
	 * @generated from rpc bundles.v1.BundleService.CreateModuleTemplateVersion
	 */
	createModuleTemplateVersion: {
		methodKind: "unary";
		input: typeof CreateModuleTemplateVersionRequestSchema;
		output: typeof CreateModuleTemplateVersionResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.PublishModuleTemplateVersion
	 */
	publishModuleTemplateVersion: {
		methodKind: "unary";
		input: typeof PublishModuleTemplateVersionRequestSchema;
		output: typeof PublishModuleTemplateVersionResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.ListModuleTemplateVersions
	 */
	listModuleTemplateVersions: {
		methodKind: "unary";
		input: typeof ListModuleTemplateVersionsRequestSchema;
		output: typeof ListModuleTemplateVersionsResponseSchema;
	};
	/**
	 * @generated from rpc bundles.v1.BundleService.TestCall
	 */
	testCall: {
		methodKind: "unary";
		input: typeof TestCallRequestSchema;
		output: typeof TestCallResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_bundles_v1_service, 0);
